<header id="page-topbar">
    <div class="navbar-header">
        <div class="d-flex">
            <!-- LOGO -->
            <div class="navbar-brand-box d-none d-lg-block d-lg-block">
                <a href="/" class="logo logo-dark">
                    <span class="logo-sm">
                        <img src="{{detailproject.urlimg}}logo.png" alt="" class="logo-img" height="22" />
                    </span>
                    <span class="logo-lg">
                        <img src="{{detailproject.urlimg}}logo.png" alt="" class="logo-img" height="30" />
                    </span>
                </a>
            </div>
            <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" (click)="toggleMenubar();"
                [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                <i class="fa fa-fw fa-bars font-size-16"></i>
            </button>
        </div>
        <div class="d-flex">
            <div class="d-inline-block d-none d-sm-block d-md-block d-lg-block d-lg-block" style="padding-top: 0px;">
                <span *ngIf="listPerusahaan.length > 1"
                    class="company-name d-none d-sm-block d-md-block d-lg-block d-lg-block" style="font-weight: 600"
                    (click)="selectPerusahaan(modal);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                    <span *ngIf="adafoto == 0">{{ user.m_perusahaan.nama }}</span>
                    <span *ngIf="adafoto == 1" class="logo-sm">
                        <img [src]="imageSrc" class="logo-img" height="25" alt="{{ user.m_perusahaan.nama }}" />
                    </span> &nbsp;<i class="fas fa-angle-down font-size-16"></i>
                </span>
                <span *ngIf="listPerusahaan.length == 1"
                    class="company-name d-none d-sm-block d-md-block d-lg-block d-lg-block"
                    style="font-weight: 600; cursor: auto;">
                    <span *ngIf="adafoto == 0">{{ user.m_perusahaan.nama }}</span>
                    <span *ngIf="adafoto == 1" class="logo-sm">
                        <img [src]="imageSrc" class="logo-img" height="25" alt="{{ user.m_perusahaan.nama }}" />
                    </span>
                </span>
            </div>
            <!-- <div class="top-nav dropdown d-inline-block" *ngIf="checkAkses('invoice')"> -->
            <div class="top-nav dropdown d-inline-block"
                *ngIf="(checkAkses('invoice') || (tipe_setting_invoice == 2 && is_session_admin_invoice)) && isAdminPic()">
                <button ngbTooltip="{{ 'Paket' | translate }}" type="button"
                    class="btn header-item noti-icon right-bar-toggle" id="page-header-notifications-dropdown"
                    (click)="reloadCurrentRoute('/master/billing');" [routerLink]="['/master/billing']" style="padding-right: 6px;
                padding-top: 3px;">
                    <!-- <i class="fa fa-file-invoice"></i> -->
                    <img *ngIf="jenis_paket == 1" src="assets/images/standart.svg" alt="paket">
                    <img *ngIf="jenis_paket == 2" src="assets/images/business.svg" alt="paket">
                    <img *ngIf="jenis_paket == 3" src="assets/images/enterprice.svg" alt="paket">
                </button>
            </div>
            <div class="top-nav dropdown d-inline-block" *ngIf="
                checkAkses('company_perusahaan') || 
                checkAkses('hari_libur') ||
                checkAkses('keuangan_komponengaji') ||
                checkAkses('penggajian_pengaturan_batas_bpjs') ||
                checkAkses('keuangan_laporan_pph') ||
                checkAkses('direktori_perusahaan') ||
                checkAkses('company_organisasi') ||
                checkAkses('company_jabatan') || 
                checkAkses('user_hakakses') ||
                checkAkses('user_approvalline') ||
                checkAkses('user_pengaturandevice')
                ">
                <button ngbTooltip="Pengaturan" type="button" class="btn header-item noti-icon right-bar-toggle"
                    id="page-header-notifications-dropdown" (click)="editcompany();"
                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                    <i class="fa fa-cog"></i>
                </button>
            </div>

            <!-- WhatsApp / Connect Channel -->
            <!-- <div class="top-nav dropdown d-inline-block">
                <button ngbTooltip="{{ (waConnected ? 'WhatsApp Terhubung' : 'Hubungkan WhatsApp') | translate }}"
                    type="button" class="btn header-item noti-icon connect-channel-btn"
                    (click)="openConnectChannel(modalConnectChannel)">
                    <i class="fab fa-whatsapp"></i>
                    <span *ngIf="!waConnected" class="connect-channel-badge"><i class="fas fa-exclamation-circle"></i></span>
                </button>
            </div> -->

            <div id="steps-settings" class="top-nav dropdown d-inline-block" *ngIf="checkAkses('company_perusahaan') ||
                  checkAkses('company_jabatan') || 
                  checkAkses('company_leveljabatan') || 
                  checkAkses('master_jadwalkerja') ||
                  checkAkses('master_timeoff') ||
                  checkAkses('master_pelatihan') ||
                  checkAkses('master_sertifikat') || 
                  checkAkses('user_approvalline') ||
                  checkAkses('master_client')" style="display: none !important;" ngbDropdown>
                <button (click)="setTutorialSettings()" type="button" class="btn header-item noti-icon right-bar-toggle"
                    id="page-header-notifications-dropdown" ngbDropdownToggle *ngIf="
                      checkAkses('user_approvalline') ||
                      checkAkses('direktori_perusahaan')">
                    <i class="fa fa-cog"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-sm dropdown-menu-right p-0" ngbDropdownMenu
                    aria-labelledby="page-header-notifications-dropdown">
                    <div class="" ngbDropdown>
                        <div class="dropdown">
                            <div class="dropdown-divider" style="margin-top: 0;"></div>
                            <div class="dropdown-item">
                                <a style="color: #495057;cursor: pointer;" (click)="editcompany();"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" class="text-black">{{ 'Perusahaan'
                                    | translate }}</a>
                            </div>
                            <div class="dropdown-divider"></div>
                            <div id="step-struktur" class="dropdown-item">
                                <a style="color: #495057;" [routerLink]="['/company/setting-ess']"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" class="text-black">{{ 'Setting ESS'
                                    | translate }}</a>
                            </div>
                            <div class="dropdown-divider" *ngIf="checkAkses('company_jabatan')"></div>
                            <div class="dropdown-item" *ngIf="checkAkses('user_approvalline')">
                                <a style="color: #495057;" href="#" [routerLink]="['/user/approvalline']"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" class="text-black">{{
                                    'GarisPersetujuan' | translate }}</a>
                            </div>
                            <div class="dropdown-divider" *ngIf="checkAkses('user_approvalline')"></div>
                            <div class="dropdown-item mb-10" *ngIf="checkAkses('direktori_perusahaan')">
                                <a style="color: #495057;" [routerLink]="['/company/direktori-perusahaan']"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" class="text-black">{{
                                    'InformasiPerusahaan' | translate }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dropdown d-inline-block" ngbDropdown style="margin-top: -5px;">
                <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
                    <ng-template #tipUser>
                        <div style="min-width: 100px; max-width: 200px; text-align: left;">
                            {{ user.jabatanTxt }}
                        </div>
                    </ng-template>
                    <!-- Start : Tampilan Semua Box -->
                    <div *ngIf="user.foto_profil !== undefined" id="allbox" class="d-md-block d-xl-inline-block ml-1"
                        style="vertical-align: middle;float: left;">
                        <!-- Start : Tampilkan Box -->
                        <div id="boxsatu" [ngStyle]="{'background-image': 'url(' + user.foto_profil + ')'}"
                            style="left: 0px;top: 0px;background-position: center;background-size: cover;z-index: 1;width: 30px;height: 30px;border-radius: 100%;position: relative;border: 1px solid #c5c1c1;">
                            <div *ngIf="translate.currentLang == 'IND'" id="boxdua"
                                style="left: -1px;bottom: -1px;z-index: 2;width: 30px;height: 10px;border-bottom-left-radius: 100px;border-bottom-right-radius: 100px;border-top-right-radius: 0px;border-top-left-radius: 0px;border-radius: 0px 0px 140px 140px/0px 0px 100px 100px;position: absolute;background-image: url('https://test.humanis.id/assets/images/flags/ind.png');background-position : center;background-size: cover;background-repeat: no-repeat;">
                            </div>
                            <div *ngIf="translate.currentLang == 'ENG'" id="boxdua"
                                style="left: 0px;bottom: 0px;z-index: 2;width: 30px;height: 10px;border-bottom-left-radius: 100px;border-bottom-right-radius: 100px;border-top-right-radius: 0px;border-top-left-radius: 0px;border-radius: 0px 0px 140px 140px/0px 0px 100px 100px;position: absolute;background-image: url('https://test.humanis.id/assets/images/flags/us.jpg');background-position : center;background-size: cover;background-repeat: no-repeat;">
                            </div>
                        </div>
                        <!-- End : Tampilan Box -->
                    </div>
                    <div *ngIf="user.foto_profil == undefined" id="allbox" class="d-md-block d-xl-inline-block ml-1"
                        style="vertical-align: middle;float: left;">
                        <!-- Start : Tampilkan Box -->
                        <div id="boxsatu"
                            style="background-image: url('assets/images/users/user-default.png');left: 0px;top: 0px;background-position: center;background-size: cover;z-index: 1;width: 30px;height: 30px;border-radius: 100%;position: relative;border: 1px solid #c5c1c1;">
                            <div *ngIf="translate.currentLang == 'IND'" id="boxdua"
                                style="left: -1px;bottom: -1px;z-index: 2;width: 30px;height: 10px;border-bottom-left-radius: 100px;border-bottom-right-radius: 100px;border-top-right-radius: 0px;border-top-left-radius: 0px;border-radius: 0px 0px 140px 140px/0px 0px 100px 100px;position: absolute;background-image: url('https://test.humanis.id/assets/images/flags/ind.png');background-position : center;background-size: cover;background-repeat: no-repeat;">
                            </div>
                            <div *ngIf="translate.currentLang == 'ENG'" id="boxdua"
                                style="left: 0px;bottom: 0px;z-index: 2;width: 30px;height: 10px;border-bottom-left-radius: 100px;border-bottom-right-radius: 100px;border-top-right-radius: 0px;border-top-left-radius: 0px;border-radius: 0px 0px 140px 140px/0px 0px 100px 100px;position: absolute;background-image: url('https://test.humanis.id/assets/images/flags/us.jpg');background-position : center;background-size: cover;background-repeat: no-repeat;">
                            </div>
                        </div>
                        <!-- End : Tampilan Box -->
                    </div>
                    <!-- End : Tampilan Semua Box -->
                    <span class="d-md-block d-xl-inline-block ml-1"
                        style="vertical-align: bottom;float: left;padding-top: 5px;padding-left: 10px;">
                        <span class="username" *ngIf="!isAdminPic(); else otherUser">
                            {{ user.nama }}
                        </span> &nbsp;
                        <ng-template #otherUser>
                            {{ 'Super Administrator' | translate }}
                        </ng-template>
                    </span>
                    <i class="fas fa-angle-down arrow-bottom"></i>
                    <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                    <a *ngIf="checkAkses('company_perusahaan')" class="dropdown-item d-sm-none"
                        href="javascript: void(0);" (click)="selectPerusahaan(modal)">
                        <i class="fas fa-building font-size-12 align-middle mr-1"></i> {{ user.m_perusahaan.nama }}
                    </a>
                    <div class="dropdown-divider d-lg-none"></div>
                    <a class="dropdown-item d-block" href="javascript: void(0);" (click)="gantiBahasa(modalGBahasa)">
                        <img *ngIf="translate.currentLang == 'ENG'" class="" src="assets/images/flags/us.jpg"
                            alt="Header Language" height="10" style="padding-right: 4px;">
                        <img *ngIf="translate.currentLang == 'IND'" class="" src="assets/images/flags/ind.png"
                            alt="Header Language" height="10" style="padding-right: 4px;"> {{ 'Bahasa' | translate }}
                    </a>
                    <!-- <div class="dropdown-divider" *ngIf="checkAkses('user_hakakses')"></div>
                    <div class="dropdown-divider d-lg-none"></div>
                    <a *ngIf="checkAkses('user_hakakses')" class="dropdown-item d-block" href="javascript: void(0);" [routerLink]="['/user/hakakses']" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" (click)="reloadCurrentRoute('/user/hakakses');">
                        <i class="fas fa-users-cog font-size-12 align-middle mr-1"></i> {{ 'HakAkses' | translate }}
                    </a> -->
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-divider d-lg-none"></div>
                    <a class="dropdown-item d-block" href="javascript: void(0);"
                        (click)="gantiPassword(modalGPassword)">
                        <i class="fas fa-key font-size-12 align-middle mr-1"></i> {{ 'GantiPassword' | translate }}
                    </a>
                    <div class="dropdown-divider" *ngIf="!isAdminPic()"></div>
                    <div class="dropdown-divider d-lg-none" *ngIf="!isAdminPic()"></div>
                    <a class="dropdown-item d-block" href="javascript: void(0);" (click)="gantiTwoAuth(modalTwoAuth)"
                        *ngIf="!isAdminPic()">
                        <i class="fas fa-user-lock font-size-12 align-middle mr-1"></i> {{ 'Two Authentication' |
                        translate }}
                    </a>
                    <!-- <div *ngIf="user.karyawan_data_id != null">
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-divider d-lg-none"></div>
                        <a class="dropdown-item d-block" href="javascript: void(0);" (click)="generateReferral()">
                            <i class="fas fa-gift font-size-12 align-middle mr-1"></i> {{ 'Referral' | translate }}
                        </a>
                    </div> -->
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-divider d-lg-none"></div>
                    <a class="dropdown-item d-block" href="javascript: void(0);" (click)="checkVersiApp()">
                        <i class="fas fa-sync font-size-12 align-middle mr-1"></i> {{ 'Update Sistem' | translate }}
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
                        <i class=" fas fa-power-off font-size-12 align-middle mr-1 text-danger"></i> {{ 'Keluar' |
                        translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</header>
<div class="topnav" id="topnav">
    <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu active  " style="float: left;">
            <div class="collapse navbar-collapse active" id="topnav-menu-content">
                <ul class="navbar-nav">
                    <li class="nav-item dropdown" id="dashboard-nav">
                        <a class="nav-link arrow-none side-nav-link-ref" id="topnav-dashboard"
                            (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                            [routerLink]="['/home']" role="button" gaEvent="click_test" gaCategory="ga_directive_test">
                            <i class="fa fa-home mr-2"></i> {{ 'Home' | translate }}
                        </a>
                    </li>
                    <!-- <li class="nav-item dropdown" *ngIf="checkAkses('karyawan_karyawan')">
                        <a class="nav-link dropdown-toggle arrow-none  side-nav-link-ref" (click)="onMenuClick($event);reloadCurrentRoute('/karyawan/karyawan');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" [routerLink]="['/karyawan/karyawan']" id="topnav-karyawan" role="button" gaEvent="click_test"
                            gaCategory="ga_directive_test">
                            <i class="fas fa-user mr-2"></i> {{ 'Karyawan' | translate }}
                        </a>
                    </li> -->



                    <li id="steps-kehadiran" class="nav-item dropdown " *ngIf="checkAkses('karyawan_karyawan') || checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPelatihan_view') ||
                    checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPendidikan_view') ||
                    checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view') || 
                    checkAksesCustom('karyawan_karyawan', 'laporanInventaris_view') ||
                    checkAksesCustom('karyawan_karyawan', 'laporanKaryawan_view')||
                    checkAkses('laporan_surat_peringatan') || checkAkses('mutasi_laporan_mutasi_karyawan') ||
                    checkAkses('mutasi_laporan_terminasi_karyawan') ||
                    checkAkses('mutasi_laporan_perubahan_kontrak') || 
                    checkAkses('perubahan_data_karyawan') || 
                    checkAksesCustom('karyawan_karyawan', 'KomponenGaji_view') || 
                    checkAkses('mutasi_perubahankontrak') || 
                    checkAkses('mutasi_mutasikaryawan') || 
                    checkAkses('surat_peringatan') || 
                    checkAkses('resign') || 
                    checkAkses('master_pengumuman') || 
                    checkAkses('laporan_komplain_karyawan')">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-karyawan"
                            role="button" (click)="onMenuClick($event);">
                            <i class="fas fa-user-check mr-2"></i> {{ 'Karyawan' | translate }}
                            <div class="arrow-down"></div>
                        </a>
                        <div class="dropdown-menu">
                            <div class="dropdown" *ngIf="checkAkses('karyawan_karyawan')" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/karyawan/karyawan']" href="#" id="topnav-lembur" role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/karyawan/karyawan');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Data Karyawan' | translate }}
                                </a>
                            </div>
                            <div class="dropdown"
                                *ngIf="checkAkses('perubahan_data_karyawan') || checkAksesCustom('karyawan_karyawan', 'KomponenGaji_view') || checkAkses('mutasi_perubahankontrak') || checkAkses('mutasi_mutasikaryawan') || checkAkses('surat_peringatan') || checkAkses('resign')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);">
                                    {{ 'Status & Perubahan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                    <!-- <a *ngIf="checkAkses('perubahan_data_karyawan')" class="dropdown-item side-nav-link-ref" [routerLink]="['/karyawan/perubahan-data']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test"
                                        (click)="onMenuClick($event);">
                                        {{ 'Data Karyawan' | translate }}
                                    </a> -->
                                    <a *ngIf="checkAkses('perubahan_data_karyawan')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/perubahan-data']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Data Karyawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'KomponenGaji_view') && (jenis_paket === 2 || jenis_paket === 3)"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/penyesuaian-gaji']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Penyesuaian Gaji' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('mutasi_perubahankontrak')"
                                        class="dropdown-item side-nav-link-ref" [routerLink]="['/mutasi/kontrak-v2']"
                                        href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Kontrak Kerja' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('mutasi_mutasikaryawan')"
                                        class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                        [routerLink]="['/mutasi/mutasi-new']" href="#" id="topnav-components"
                                        role="button" (click)="onMenuClick($event);"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test">
                                        {{ 'Mutasi' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('surat_peringatan')"
                                        class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                        [routerLink]="['/mutasi/new-sp']" href="#" id="topnav-components" role="button"
                                        (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        {{ 'Surat Peringatan' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('resign')"
                                        class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                        [routerLink]="['/karyawan/resign']" href="#" id="topnav-components"
                                        role="button" (click)="onMenuClick($event);"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test">
                                        {{ 'Resign' | translate }}
                                    </a>
                                </div>
                            </div>
                            <div class="dropdown" *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPelatihan_view') ||
                                                        checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPendidikan_view') ||
                                                        checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view') || 
                                                        checkAksesCustom('karyawan_karyawan', 'laporanInventaris_view') ||
                                                        checkAksesCustom('karyawan_karyawan', 'laporanKaryawan_view')||
                                                        checkAkses('laporan_surat_peringatan')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);">
                                    {{ 'Laporan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/rekap-karyawan/0']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Rekap karyawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/rekap-device']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Rekap Device' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPelatihan_view')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/laporan-riwayat-pelatihan']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Pelatihan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPendidikan_view')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/laporan-riwayat-pendidikan']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Pendidikan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanInventaris_view')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/laporan-inventaris']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Inventaris' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanKaryawan_view')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/karyawan/laporan-karyawan']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Database Karyawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('laporan_surat_peringatan')"
                                        class="dropdown-item side-nav-link-ref"
                                        [routerLink]="['/mutasi/laporan-surat-peringatan']" href="#"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Surat Peringatan' | translate }}
                                    </a>
                                    <div class="dropdown" *ngIf="checkAkses('mutasi_laporan_mutasi_karyawan') ||
                                                         checkAkses('mutasi_laporan_terminasi_karyawan') ||
                                                         checkAkses('mutasi_laporan_perubahan_kontrak')
                                                         ">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button" (click)="onMenuClick($event);">
                                            {{ 'Mutasi' | translate }}
                                            <div class="arrow-down"></div>
                                        </a>
                                        <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                            <a *ngIf="checkAkses('mutasi_laporan_terminasi_karyawan')"
                                                class="dropdown-item side-nav-link-ref"
                                                [routerLink]="['/mutasi/laporan-terminasi']" href="#"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'KaryawanKeluar' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('mutasi_laporan_mutasi_karyawan')"
                                                class="dropdown-item side-nav-link-ref"
                                                [routerLink]="['/mutasi/laporan-mutasi-karyawan']" href="#"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'MutasiKaryawan' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('mutasi_laporan_perubahan_kontrak')"
                                                class="dropdown-item side-nav-link-ref"
                                                [routerLink]="['/mutasi/laporan-kontrak']" href="#"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'KontrakKaryawan' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('mutasi_laporan_perubahan_kontrak')"
                                                class="dropdown-item side-nav-link-ref"
                                                [routerLink]="['/mutasi/laporan-sisa-kontrak']" href="#"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'Sisa Kontrak' | translate }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                <a *ngIf="checkAkses('master_pengumuman')"
                                    class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/master/pengumuman','2']" href="#" id="topnav-lembur" role="button"
                                    (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Memo' | translate }}
                                </a>
                            </div>
                            <div class="dropdown">
                                <a *ngIf="checkAkses('laporan_komplain_karyawan')"
                                    class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/company/komplain']" href="#" id="topnav-components" role="button"
                                    (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                    gaEvent="click_test" gaCategory="ga_directive_test">
                                    {{ 'Komplain Karyawan' | translate }}
                                </a>
                            </div>
                        </div>
                    </li>
                    <li id="steps-kehadiran" class="nav-item dropdown " *ngIf="(checkAkses('master_jadwalkerja') ||
                            checkAkses('kehadiran_riwayat_kehadiran') ||
                            checkAkses('kehadiran_kunjunganklien') ||
                            checkAkses('kehadiran_lembur') ||
                            checkAkses('kehadiran_tukarshift') || checkAksesCustom('kehadiran_dinasluar', 'view') ||
                            checkAkses('master_dinas_luar') ||
                            checkAkses('kehadiran_tukaroff') ||
                            checkAkses('kehadiran_izin') ||
                            checkAkses('master_saldo_cuti') ||
                            checkAkses('kehadiran_laporan_lembur') || checkAkses('kehadiran_laporan_saldo_izin') || checkAkses('kehadiran_laporan_izin') || checkAkses('kehadiran_laporan_jadwal_kerja') || checkAkses('kehadiran_laporan_riwayat_kehadiran') ||
                            checkAkses('kehadiran_laporan_riwayat_kehadiran') ||
                            checkAkses('kehadiran_laporan_riwayat_kehadiran')) && (jenis_paket === 1 || jenis_paket === 3)
                        ">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-kehadiran"
                            role="button" (click)="onMenuClick($event);">
                            <i class="fas fa-calendar mr-2"></i> {{ 'Attendance' | translate }}
                            <div class="arrow-down"></div>
                        </a>
                        <div class="dropdown-menu">
                            <div *ngIf="
                                checkAkses('master_jadwalkerja') && 
                                (checkAkses('kehadiran_jadwal_kerja_flat') ||
                                checkAkses('kehadiran_jadwal_kerja_shift') ||
                                checkAkses('master_jadwalkerja || kehadiran_master_kehadiran')
                                ) && dataPerusahaan.jadwal_version == 1
                                " class="dropdown">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'JadwalKerja' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="topnav-email" gaEvent="click_test"
                                    gaCategory="ga_directive_test">
                                    <!-- <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" *ngIf="checkAkses('kehadiran_master_kehadiran')" [routerLink]="['/kehadiran/kalender']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/kalender');"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                        {{ 'HariLibur' | translate }}
                                    </a> -->
                                    <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                        *ngIf="checkAkses('kehadiran_jadwal_kerja_flat')"
                                        [routerLink]="['/kehadiran/jadwal-kerja-flat', 1]" href="#"
                                        id="topnav-components" role="button"
                                        (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/jadwal-kerja-flat/1');"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test">
                                        {{ 'JadwalFlat' | translate }}
                                    </a>
                                    <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                        *ngIf="checkAkses('kehadiran_jadwal_kerja_shift')"
                                        [routerLink]="['/kehadiran/jadwal-kerja-flat', 2]" href="#"
                                        id="topnav-components" role="button"
                                        (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/jadwal-kerja-flat/2');"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test">
                                        {{ 'JadwalShift' | translate }}
                                    </a>
                                    <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                        *ngIf="checkAkses('kehadiran_jadwal_kerja_flat')"
                                        [routerLink]="['/master/tukar-jadwal-kerja']" href="#" id="topnav-components"
                                        role="button"
                                        (click)="onMenuClick($event); reloadCurrentRoute('/master/tukar-jadwal-kerja');"
                                        [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test">
                                        {{ 'Tukar Jadwal Kerja' | translate }}
                                    </a>
                                </div>
                            </div>
                            <div *ngIf="dataPerusahaan.jadwal_version == 2 && checkAkses('master_jadwalkerja')"
                                class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/jadwal-kerja-new']" href="#" id="topnav-components"
                                    role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/jadwal-kerja-new');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Jadwal Kerja' | translate }}
                                </a>
                            </div>
                            <div *ngIf="checkAkses('kehadiran_riwayat_kehadiran')" class="dropdown" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/riwayat-kehadiran']" href="#" id="topnav-components"
                                    role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/riwayat-kehadiran');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'CheckClock' | translate }}
                                </a>
                            </div>
                            <div *ngIf="checkAkses('kehadiran_kunjunganklien')" class="dropdown" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/kunjungan-klien']" href="#" id="topnav-components"
                                    role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/kunjungan-klien');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Kunjungan Klien' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" *ngIf="checkAkses('kehadiran_lembur')" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/lembur','0']" href="#" id="topnav-lembur" role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/lembur/0');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Lembur' | translate }}
                                </a>
                            </div>
                            <!-- <div class="dropdown" *ngIf="checkAkses('kehadiran_tukarshift') && !isStagging" gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/kehadiran/tukarshift']" href="#" id="topnav-tukarshift" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/tukarshift');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Tukar Shift' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" *ngIf="checkAkses('kehadiran_tukarshift') && isStagging" gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/kehadiran/tukarshift-new']" href="#" id="topnav-tukarshift" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/tukarshift-new');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Tukar Shift' | translate }}
                                </a>
                            </div> -->
                            <div class="dropdown"
                                *ngIf="checkAkses('kehadiran_tukarshift') || checkAkses('kehadiran_tukaroff') || checkAksesCustom('kehadiran_dinasluar', 'view')"
                                gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);">
                                    {{ 'Perubahan Jadwal' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right">
                                    <div *ngIf="checkAkses('master_dinas_luar')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/kehadiran/dinasluar']" href="#" id="topnav-components"
                                            role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/dinasluar');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Dinas Luar' | translate }}
                                        </a>
                                    </div>
                                    <div *ngIf="checkAkses('kehadiran_tukarshift')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/kehadiran/tukarshift-new']" href="#" id="topnav-components"
                                            role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/tukarshift-new');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Tukar Shift' | translate }}
                                        </a>
                                    </div>
                                    <div *ngIf="checkAkses('kehadiran_tukaroff')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/kehadiran/tukaroff']" href="#" id="topnav-components"
                                            role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/tukaroff');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Tukar Off' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="checkAkses('kehadiran_izin')" class="dropdown" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/izin','0']" href="#" id="topnav-components" role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/izin/0');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Izin' | translate }}
                                </a>
                            </div>
                            <div *ngIf="checkAkses('master_saldo_cuti')" class="dropdown" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/setting-cuti']" href="#" id="topnav-components"
                                    role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/setting-cuti');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Cuti Tahunan' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" *ngIf="checkAkses('kehadiran_laporan_lembur') ||
                                checkAkses('kehadiran_laporan_saldo_izin') ||
                                checkAkses('kehadiran_laporan_izin') ||
                                checkAkses('kehadiran_laporan_jadwal_kerja') ||
                                checkAkses('kehadiran_laporan_riwayat_kehadiran')
                            " style="display: none;">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/kehadiran/laporan-hadir']" href="#" id="topnav-components"
                                    role="button" (click)="onMenuClick($event); "
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" (click)="onMenuClick($event);">
                                    {{ 'Laporan' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test"
                                *ngIf="checkAkses('kehadiran_laporan_lembur') || checkAkses('kehadiran_laporan_saldo_izin') || checkAkses('kehadiran_laporan_izin') || checkAkses('kehadiran_laporan_jadwal_kerja') || checkAkses('kehadiran_laporan_riwayat_kehadiran')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);">
                                    {{ 'Laporan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right">
                                    <div class="dropdown" *ngIf="checkAkses('kehadiran_laporan_riwayat_kehadiran')">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/kehadiran/laporan-hadir']" href="#" id="topnav-components"
                                            role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/laporan-hadir');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Kehadiran' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" *ngIf="checkAkses('kehadiran_laporan_riwayat_kehadiran')">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/kehadiran/laporan-hadir-rekap']" href="#"
                                            id="topnav-components" role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/laporan-hadir-rekap');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Rekap Kehadiran' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" *ngIf="checkAkses('kehadiran_laporan_riwayat_kehadiran')">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/kehadiran/monitoring-cuti-baru']" href="#"
                                            id="topnav-components" role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/kehadiran/monitoring-cuti-baru');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Monitoring Cuti' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="dropdown" *ngIf="checkAkses('kehadiran_laporan_lembur') ||
                                checkAkses('kehadiran_laporan_saldo_izin') ||
                                checkAkses('kehadiran_laporan_izin') ||
                                checkAkses('kehadiran_laporan_jadwal_kerja') ||
                                checkAkses('kehadiran_laporan_riwayat_kehadiran')
                            ">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/kehadiran/laporan-hadir-new']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); " [ngClass]="{ 'disabled':  is_masa_aktif_habis }" (click)="onMenuClick($event);">
                                    {{ 'Laporan' | translate }}
                                </a>
                            </div> -->
                        </div>
                    </li>
                    <li class="nav-item dropdown"
                        *ngIf="checkAkses('keuangan_pengajuan_reimbursement') && (jenis_paket === 2 || jenis_paket === 3)">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" href="#"
                            id="topnav-reimbursement" role="button" (click)="onMenuClick($event)">
                            <i class="fas fa-money-bill-alt mr-2"></i> {{ 'Reimbursement' | translate }}
                            <div class="arrow-down"></div>
                        </a>
                        <div class="dropdown-menu">
                            <div class="dropdown" *ngIf="checkAkses('keuangan_pengajuan_reimbursement')"
                                gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/keuangan/pengajuan-reimbursement','0']" href="#"
                                    id="topnav-components" role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/pengajuan-reimbursement/0');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Reimbursement' | translate }}
                                </a>
                            </div>
                            <div class="dropdown"
                                *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement') || checkAkses('keuangan_laporan_reimbursement')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Laporan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                    <div *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement') || checkAkses('keuangan_laporan_reimbursement')"
                                        class="dropdown">
                                        <a *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement')"
                                            [routerLink]="['/keuangan/laporan-saldo-reimbursement']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'SaldoReimbursement' | translate }}
                                        </a>
                                        <a *ngIf="checkAkses('keuangan_laporan_reimbursement')"
                                            [routerLink]="['/keuangan/laporan-reimbursement']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'Reimbursement' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown"
                        *ngIf="(checkAkses('keuangan_kasbon') || checkAkses('keuangan_penggajian')) && (jenis_paket === 2 || jenis_paket === 3)">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-keuangan"
                            role="button" (click)="onMenuClick($event)">
                            <i class="fas fa-wallet mr-2"></i> {{ 'Payroll' | translate }}
                            <div class="arrow-down"></div>
                        </a>
                        <div class="dropdown-menu">
                            <!-- <div class="dropdown" *ngIf="checkAkses('keuangan_pengajuan_reimbursement')" gaEvent="click_test" gaCategory="ga_directive_test" style="display: none;">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/keuangan/pengajuan-reimbursement','0']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/pengajuan-reimbursement/0');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Reimbursement' | translate }}
                                </a>
                            </div> -->
                            <div class="dropdown" *ngIf="checkAkses('keuangan_penggajian')" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/keuangan/penggajian']" href="#" id="topnav-components"
                                    role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/penggajian');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Penggajian' | translate }}
                                </a>
                            </div>
                            <!-- <div class="dropdown" *ngIf="checkAkses('keuangan_penggajian')" gaEvent="click_test"
                                gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/keuangan/penggajian']" href="#" id="topnav-components"
                                    role="button"
                                    (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/penggajian-v2');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Penggajian V2' | translate }}
                                </a>
                            </div> -->
                            <!-- <div class="dropdown" *ngIf="checkAkses('keuangan_kasbon')" gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/keuangan/kasbon','0']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/kasbon/0');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Pinjaman' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" *ngIf="checkAkses('keuangan_kasbon')" gaEvent="click_test" gaCategory="ga_directive_test">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/keuangan/riwayat-bayar-kasbon']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/riwayat-bayar-kasbon');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Bayar Pinjaman' | translate }}
                                </a>
                            </div> -->
                            <div class="dropdown" *ngIf="checkAkses('keuangan_kasbon')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Pinjaman' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                    <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/kasbon','0']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'Pinjaman' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/riwayat-bayar-kasbon']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'Bayar Pinjaman' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="dropdown" *ngIf="checkAkses('keuangan_penggajian')" gaEvent="click_test" gaCategory="ga_directive_test" style="display: none;">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/keuangan/pagetest']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/pagetest');"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Page Test' | translate }}
                                </a>
                            </div> -->
                            <div class="dropdown" *ngIf="checkAkses('keuangan_laporan_kasbon') ||
                                                         checkAkses('keuangan_laporan_pembayaran_kasbon') ||
                                                         checkAkses('keuangan_laporan_pph') ||
                                                         checkAkses('keuangan_laporan_gaji') ||
                                                         checkAkses('keuangan_laporan_komponen_gaji') ||
                                                         checkAkses('keuangan_laporan_bpjs')
                                                    ">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Laporan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                    <div class="dropdown d-none"
                                        *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon') || checkAkses('keuangan_laporan_kasbon')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/keuangan/laporan-kasbon']" href="#" id="topnav-components"
                                            role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/laporan-kasbon');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Pinjaman' | translate }}
                                        </a>
                                    </div>
                                    <div *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon') || checkAkses('keuangan_laporan_kasbon')"
                                        class="dropdown" style="display: none;">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button" (click)="onMenuClick($event);"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Pinjaman' | translate }}aaa
                                            <div class="arrow-down"></div>
                                        </a>
                                        <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                            <a style="display: none;"
                                                *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon')"
                                                class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                (click)="onMenuClick($event);"
                                                [routerLink]="['/keuangan/laporan-pembayaran-kasbon']" href="#"
                                                id="topnav-components" role="button"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test">
                                                {{ 'Pinjaman' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_kasbon') || checkAkses('keuangan_laporan_pembayaran_kasbon')"
                                                class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                (click)="onMenuClick($event);"
                                                [routerLink]="['/keuangan/laporan-kasbon']" href="#"
                                                id="topnav-components" role="button"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test">
                                                {{ 'RekapPinjaman' | translate }}
                                            </a>
                                        </div>
                                    </div>
                                    <!-- <div *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement') || checkAkses('keuangan_laporan_reimbursement')" class="dropdown d-none">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Reimbursement' | translate }}
                                            <div class="arrow-down"></div>
                                        </a>
                                        <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                            <a *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement')" [routerLink]="['/keuangan/laporan-saldo-reimbursement']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'SaldoReimbursement' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_reimbursement')" [routerLink]="['/keuangan/laporan-reimbursement']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'Reimbursement' | translate }}
                                            </a>
                                        </div>
                                    </div> -->
                                    <!-- <div *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_komponen_gaji')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event)">
                                            {{ 'Penggajian' | translate }}
                                            <div class="arrow-down"></div>
                                        </a>
                                        <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                            <a *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')" [routerLink]="['/keuangan/laporan-payroll']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'Penggajian' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')" [routerLink]="['/keuangan/laporan-bpjs-ket']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'BPJS Ketenagakerjaan' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')" [routerLink]="['/keuangan/laporan-bpjs-kes']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'BPJS Kesehatan' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_komponen_gaji')" [routerLink]="['/keuangan/laporan-komponen-gaji']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);" style="display: none;">
                                                {{ 'KomponenGaji' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_gaji')" [routerLink]="['/keuangan/laporan-riwayat-gaji']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);" style="display: none;">
                                                {{ 'Riwayat Gaji' | translate }}
                                            </a>
                                            <a [routerLink]="['/keuangan/laporan-pph']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'PPh 21' | translate }}
                                            </a>
                                        </div>
                                    </div> -->
                                    <div class="dropdown"
                                        *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/laporan-payroll']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'Penggajian' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown"
                                        *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/laporan-bpjs-ket']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'BPJS Ketenagakerjaan' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown"
                                        *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/laporan-bpjs-kes']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'BPJS Kesehatan' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" *ngIf="checkAkses('keuangan_laporan_komponen_gaji')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/laporan-komponen-gaji']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);"
                                            style="display: none;">
                                            {{ 'KomponenGaji' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" *ngIf="checkAkses('keuangan_laporan_gaji')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/laporan-riwayat-gaji']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);"
                                            style="display: none;">
                                            {{ 'Riwayat Gaji' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" *ngIf="checkAkses('keuangan_laporan_pph')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/laporan-pph']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'PPh 21' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown"
                                        *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon') || checkAkses('keuangan_laporan_kasbon')"
                                        gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                            [routerLink]="['/keuangan/laporan-kasbon']" href="#" id="topnav-components"
                                            role="button"
                                            (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/laporan-kasbon');"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Pinjaman' | translate }}
                                        </a>
                                    </div>
                                    <div *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon') || checkAkses('keuangan_laporan_kasbon')"
                                        class="dropdown" style="display: none;">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button" (click)="onMenuClick($event);"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Pinjaman' | translate }}aaa
                                            <div class="arrow-down"></div>
                                        </a>
                                        <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                            <a style="display: none;"
                                                *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon')"
                                                class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                (click)="onMenuClick($event);"
                                                [routerLink]="['/keuangan/laporan-pembayaran-kasbon']" href="#"
                                                id="topnav-components" role="button"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test">
                                                {{ 'Pinjaman' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_kasbon') || checkAkses('keuangan_laporan_pembayaran_kasbon')"
                                                class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                (click)="onMenuClick($event);"
                                                [routerLink]="['/keuangan/laporan-kasbon']" href="#"
                                                id="topnav-components" role="button"
                                                [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                                gaCategory="ga_directive_test">
                                                {{ 'RekapPinjaman' | translate }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="dropdown">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                    id="topnav-components" role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Pembayaran' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-right" aria-labelledby="topnav-email">
                                    <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/pembayaran-bpjs-kesehatan']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'BPJS Kesehatan' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/pembayaran-bpjs-ketenagakerjaan']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'BPJS Ketenagakerjaan' | translate }}
                                        </a>
                                    </div>
                                    <div class="dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                                        <a [routerLink]="['/keuangan/pembayaran-pph21']"
                                            class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#"
                                            id="topnav-components" role="button"
                                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                            gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                            {{ 'PPh 21' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <!-- <li *ngIf="checkAkses('keuangan_penggajian')" class="nav-item dropdown" gaEvent="click_test" gaCategory="ga_directive_test">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/keuangan/penggajian']" (click)="reloadCurrentRoute('/keuangan/penggajian');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" href="#" id="topnav-penggajian" role="button">
                            <i class="fas fa-money-bill-alt fa-xs mr-2"></i> {{ 'Penggajian' | translate }}
                        </a>
                    </li> -->
                    <!-- <li class="nav-item dropdown" *ngIf="checkAkses('kpi_new')" gaEvent="click_test" gaCategory="ga_directive_test">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/kpi/pengaturan-kpi']" (click)="onMenuClick($event);reloadCurrentRoute('/kpi/pengaturan-kpi');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" href="#" id="topnav-kpi" role="button">
                            <i class="fas fa-chart-bar fa-xs mr-2"></i> {{ 'KPI' | translate }}
                        </a>
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-keuangan" role="button" (click)="onMenuClick($event)">
                            <i class="far fa-money-bill-alt mr-2"></i>
                            {{ 'KPI' | translate }}
                            <div class="arrow-down"></div>
                        </a>
                        <div class="dropdown-menu">
                            <div class="dropdown" >
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/kpi/pengaturan-kpi']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/kpi/pengaturan-kpi')">
                                    {{ 'Pengaturan KPI' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" *ngIf="checkAkses('keuangan_pengajuan_reimbursement')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/keuangan/pengajuan-reimbursement','0']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); reloadCurrentRoute('/keuangan/pengajuan-reimbursement/0')">
                                    {{ 'Reimbursement' | translate }}
                                </a>
                            </div>
                        </div>
                    </li> -->
                    <li class="nav-item dropdown" *ngIf="checkAkses('informasi_recruitment') && jenis_paket === 3"
                        gaEvent="click_test" gaCategory="ga_directive_test">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref"
                            [routerLink]="['/recruitment/dashboard']"
                            (click)="onMenuClick($event); reloadCurrentRoute('/recruitment/dashboard');"
                            [ngClass]="{ 'disabled':  is_masa_aktif_habis }" href="#" id="topnav-recruitment"
                            role="button">
                            <i class="fas fa-user-friends fa-xs mr-2"></i> {{ 'Recruitment' | translate }}
                        </a>
                    </li>
                    <!-- NON AKTIFKAN SCREENING -->
                    <!-- <li class="nav-item dropdown" *ngIf="checkAkses('screening')" gaEvent="click_test" gaCategory="ga_directive_test">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/master/screening']" (click)="reloadCurrentRoute('/master/screening');" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" href="#" id="topnav-screening" role="button">
                            <i class="fas fa-tablet-alt fa-xs mr-2"></i> {{ 'Screening Covid 19' | translate }}
                        </a>
                    </li> -->
                    <li style="display: block;" class="nav-item dropdown" *ngIf="checkAkses('mutasi_laporan_mutasi_karyawan') ||
                                                          checkAkses('mutasi_laporan_terminasi_karyawan') ||
                                                          checkAkses('mutasi_laporan_perubahan_kontrak') ||
                                                          checkAkses('kehadiran_laporan_lembur') ||
                                                          checkAkses('kehadiran_laporan_saldo_izin') ||
                                                          checkAkses('kehadiran_laporan_izin') ||
                                                          checkAkses('kehadiran_laporan_jadwal_kerja') ||
                                                          checkAkses('kehadiran_laporan_riwayat_kehadiran') ||
                                                          checkAkses('keuangan_laporan_kasbon') ||
                                                          checkAkses('keuangan_laporan_pembayaran_kasbon') ||
                                                          checkAkses('keuangan_laporan_saldo_reimbursement') ||
                                                          checkAkses('keuangan_laporan_reimbursement') ||
                                                          checkAkses('keuangan_laporan_pph') ||
                                                          checkAkses('keuangan_laporan_gaji') ||
                                                          checkAkses('keuangan_laporan_komponen_gaji') ||
                                                          checkAkses('keuangan_laporan_bpjs') || 
                                                          checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPelatihan_view') ||
                                                          checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPendidikan_view') ||
                                                          checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view') || 
                                                          checkAksesCustom('karyawan_karyawan', 'laporanInventaris_view') ||
                                                          checkAksesCustom('karyawan_karyawan', 'laporanKaryawan_view') ||
                                                          checkAkses('screening')
                                                            ">
                        <a class="nav-link dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-laporan"
                            role="button" (click)="onMenuClick($event);" style="display: none;">
                            <i class="far fa-file-alt mr-2"></i> {{ 'Laporan' | translate }}
                            <div class="arrow-down"></div>
                        </a>
                        <div class="dropdown-menu">
                            <!-- <div class="dropdown" *ngIf="checkAkses('keuangan_laporan_kasbon') ||
                                                         checkAkses('keuangan_laporan_pembayaran_kasbon') ||
                                                         checkAkses('keuangan_laporan_saldo_reimbursement') ||
                                                         checkAkses('keuangan_laporan_reimbursement') ||
                                                         checkAkses('keuangan_laporan_pph') ||
                                                         checkAkses('keuangan_laporan_gaji') ||
                                                         checkAkses('keuangan_laporan_komponen_gaji') ||
                                                         checkAkses('keuangan_laporan_bpjs')
                                                    ">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                    {{ 'Keuangan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-left" aria-labelledby="topnav-email">
                                    <div *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon') || checkAkses('keuangan_laporan_kasbon')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Pinjaman' | translate }}
                                        </a>
                                        <div class="dropdown-menu go-left" aria-labelledby="topnav-email">
                                            <a *ngIf="checkAkses('keuangan_laporan_pembayaran_kasbon')" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" (click)="onMenuClick($event);" [routerLink]="['/keuangan/laporan-pembayaran-kasbon']" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test">
                                                {{ 'Pinjaman' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_kasbon')" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" (click)="onMenuClick($event);" [routerLink]="['/keuangan/laporan-kasbon']" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test">
                                                {{ 'RekapPinjaman' | translate }}
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement') || checkAkses('keuangan_laporan_reimbursement')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }">
                                            {{ 'Reimbursement' | translate }}
                                        </a>
                                        <div class="dropdown-menu go-left" aria-labelledby="topnav-email">
                                            <a *ngIf="checkAkses('keuangan_laporan_saldo_reimbursement')" [routerLink]="['/keuangan/laporan-saldo-reimbursement']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'SaldoReimbursement' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_reimbursement')" [routerLink]="['/keuangan/laporan-reimbursement']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'Reimbursement' | translate }}
                                            </a>
                                        </div>
                                    </div>
                                    <div *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_komponen_gaji')" class="dropdown">
                                        <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event)">
                                            {{ 'Penggajian' | translate }}
                                        </a>
                                        <div class="dropdown-menu go-left" aria-labelledby="topnav-email">
                                            <!-- penggajian sendiri -->
                            <!-- <a *ngIf="checkAkses('keuangan_laporan_gaji')" [routerLink]="['/keuangan/laporan-gaji']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button">
                                                {{ 'Penggajian' | translate }}
                                            </a> -->

                            <!-- penggajian jadi satu -->
                            <!-- <a *ngIf="checkAkses('keuangan_laporan_gaji') || checkAkses('keuangan_laporan_bpjs') || checkAkses('keuangan_laporan_pph') || checkAkses('keuangan_laporan_pph')" [routerLink]="['/keuangan/laporan-payroll']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                                href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'Penggajian' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_komponen_gaji')" [routerLink]="['/keuangan/laporan-komponen-gaji']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'KomponenGaji' | translate }}
                                            </a>
                                            <a *ngIf="checkAkses('keuangan_laporan_gaji')" [routerLink]="['/keuangan/laporan-riwayat-gaji']" class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                                gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                                {{ 'Riwayat Gaji' | translate }}
                                            </a>
                                        </div>
                                    </div> -->
                            <!-- <a href="#" *ngIf="checkAkses('keuangan_laporan_bpjs')" [routerLink]="['/keuangan/laporan-bpjs']" class="dropdown-item side-nav-link-ref">{{ 'BPJS' | translate }}</a>
                                    <a href="#" *ngIf="checkAkses('keuangan_laporan_pph')" [routerLink]="['/keuangan/laporan-pph']" class="dropdown-item side-nav-link-ref">{{ 'PPH21' | translate }}</a>
                                    <a href="#" *ngIf="checkAkses('keuangan_laporan_pph')" [routerLink]="['/keuangan/laporan-espt']" class="dropdown-item side-nav-link-ref">{{ 'ESPT' | translate }}</a> -->

                            <!-- </div>
                            </div>  -->
                            <!-- <div class="dropdown" *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPelatihan_view') ||
                                                        checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPendidikan_view') ||
                                                        checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view') || 
                                                        checkAksesCustom('karyawan_karyawan', 'laporanInventaris_view') ||
                                                        checkAksesCustom('karyawan_karyawan', 'laporanKaryawan_view')||
                                                        checkAkses('laporan_surat_peringatan')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event);">
                                    {{ 'Karyawan' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-left" aria-labelledby="topnav-email">
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRekapKaryawan_view')" class="dropdown-item side-nav-link-ref" [routerLink]="['/karyawan/rekap-karyawan/0']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Rekap karyawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPelatihan_view')" class="dropdown-item side-nav-link-ref" [routerLink]="['/karyawan/laporan-riwayat-pelatihan']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Pelatihan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanRiwayatPendidikan_view')" class="dropdown-item side-nav-link-ref" [routerLink]="['/karyawan/laporan-riwayat-pendidikan']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                        gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Pendidikan' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanInventaris_view')" class="dropdown-item side-nav-link-ref" [routerLink]="['/karyawan/laporan-inventaris']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Inventaris' | translate }}
                                    </a>
                                    <a *ngIf="checkAksesCustom('karyawan_karyawan', 'laporanKaryawan_view')" class="dropdown-item side-nav-link-ref" [routerLink]="['/karyawan/laporan-karyawan']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Database Karyawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('laporan_surat_peringatan')" class="dropdown-item side-nav-link-ref" [routerLink]="['/mutasi/laporan-surat-peringatan']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Surat Peringatan' | translate }}
                                    </a>
                                </div>
                            </div> -->
                            <!-- <div class="dropdown" *ngIf="checkAkses('mutasi_laporan_mutasi_karyawan') ||
                                                         checkAkses('mutasi_laporan_terminasi_karyawan') ||
                                                         checkAkses('mutasi_laporan_perubahan_kontrak')
                                                         ">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" href="#" id="topnav-components" role="button" (click)="onMenuClick($event);">
                                    {{ 'Mutasi' | translate }}
                                    <div class="arrow-down"></div>
                                </a>
                                <div class="dropdown-menu go-left" aria-labelledby="topnav-email">
                                    <a *ngIf="checkAkses('mutasi_laporan_terminasi_karyawan')" class="dropdown-item side-nav-link-ref" [routerLink]="['/mutasi/laporan-terminasi']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'KaryawanKeluar' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('mutasi_laporan_mutasi_karyawan')" class="dropdown-item side-nav-link-ref" [routerLink]="['/mutasi/laporan-mutasi-karyawan']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'MutasiKaryawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('mutasi_laporan_perubahan_kontrak')" class="dropdown-item side-nav-link-ref" [routerLink]="['/mutasi/laporan-kontrak']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'KontrakKaryawan' | translate }}
                                    </a>
                                    <a *ngIf="checkAkses('mutasi_laporan_perubahan_kontrak')" class="dropdown-item side-nav-link-ref" [routerLink]="['/mutasi/laporan-sisa-kontrak']" href="#" [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test" gaCategory="ga_directive_test" (click)="onMenuClick($event);">
                                        {{ 'Sisa Kontrak' | translate }}
                                    </a>
                                </div>
                            </div> -->
                            <!-- kehadiran jadi satu -->
                            <!-- <div class="dropdown" *ngIf="checkAkses('kehadiran_laporan_lembur') ||
                                checkAkses('kehadiran_laporan_saldo_izin') ||
                                checkAkses('kehadiran_laporan_izin') ||
                                checkAkses('kehadiran_laporan_jadwal_kerja') ||
                                checkAkses('kehadiran_laporan_riwayat_kehadiran')
                            ">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref" [routerLink]="['/kehadiran/laporan-hadir']" href="#" id="topnav-components" role="button" (click)="onMenuClick($event); " [ngClass]="{ 'disabled':  is_masa_aktif_habis }" (click)="onMenuClick($event);">
                                    {{ 'Kehadiran' | translate }}
                                </a>
                            </div> -->
                            <div class="dropdown" *ngIf="checkAkses('laporan_legalitas')">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/company/laporan-legalitas']" href="#" id="topnav-components"
                                    role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                    gaCategory="ga_directive_test">
                                    {{ 'Legalitas' | translate }}
                                </a>
                            </div>
                            <div class="dropdown"
                                *ngIf="checkAkses('struktur_organisasi') || checkAkses('struktur_jabatan')"
                                style="display: none;">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/company/laporan-struktur']" href="#" id="topnav-components"
                                    role="button" (click)="onMenuClick($event);"
                                    [ngClass]="{ 'disabled':  is_masa_aktif_habis }" gaEvent="click_test"
                                    gaCategory="ga_directive_test">
                                    {{ 'Struktur' | translate }}
                                </a>
                            </div>
                            <div class="dropdown" *ngIf="checkAkses('laporan_aktivitas_pengguna')"
                                style="display: none;">
                                <a class="dropdown-item dropdown-toggle arrow-none side-nav-link-ref"
                                    [routerLink]="['/user/userLog']" href="#" id="topnav-components" role="button"
                                    (click)="onMenuClick($event);" [ngClass]="{ 'disabled':  is_masa_aktif_habis }"
                                    gaEvent="click_test" gaCategory="ga_directive_test">
                                    {{ 'User Activity' | translate }}
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu active" style="float: right;">
            <div class="collapse navbar-collapse active" id="topnav-menu-content">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link arrow-none" id="topnav-paket" role="button"
                            style="padding-right: 0px;padding-top: 0px;padding-bottom: 0px;margin-top: 7px;">
                            <div class="input-group input-group-sm">
                                <ng-select class="ng-select-filter-topbar" [items]="listKaryawanFilter"
                                    bindLabel="nama_select" bindValue="id" [(ngModel)]="idkaryawanfilter"
                                    name="idkaryawanfilter" (change)="searchKaryawan(idkaryawanfilter);"
                                    placeholder="{{'Cari Karyawan' | translate}} " appendTo="body"
                                    (keyup)="getKaryawanSearch($event.target.value)" (clear)="resetCalculations();">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.nama}} <br />
                                        <small class="d-flex">
                                            {{item.nama_jabatan}}
                    <li *ngIf="item.status == 2 && item.is_deleted == 0" class="ml-3 text-warning">{{ 'Resign' |
                        translate }}</li>
                    <li *ngIf="(item.status == 1 || item.status == 2) && item.is_deleted == 1"
                        class="ml-3 text-warning">{{ 'Deleted' | translate }}</li>
                    </small>
                    </ng-template>
                    </ng-select>
                    <div class="input-group-append ">
                        <span class="input-group-text">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
            </div>
            </a>
            <!-- <a class="nav-link arrow-none" (click)="getAllPaket(modalPaketData)" id="topnav-paket" role="button" style="padding-right: 0px;">
                            <span style="font-weight: bold; text-transform: uppercase;">&nbsp;&nbsp;{{ clientDetail.nama_paket}}</span>
                            <span style="font-weight: normal !important;" *ngIf="clientDetail.status == 2"> - DEMO</span>
                            <span style="font-weight: normal !important;" *ngIf="clientDetail.status == 4"> - FREE</span>
                        </a> -->
            </li>
            </ul>
    </div>
    </nav>
</div>
</div>
<ng-template #modal let-modal>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-11">
                    <h5 class="modal-title mt-0"> {{ 'Perusahaan' | translate }}</h5>
                    <p class="text-muted mb-0" style="font-size: 11px; color: #fff !important;">{{'Anda Mempunyai Akses'
                        | translate}} {{ listPerusahaan.length }} / {{jumlahSemuaPerusahaan}} {{ 'Perusahaan' |
                        translate }}</p>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body perusahaan">
        <div class="container">
            <div class="col-md-12 p-0"
                *ngIf="!isRestorePerusahaan && jumlahPerusahaanTerhapus > 0 && jumlahSemuaPerusahaan < max_perusahaan && checkAkses('multiple_branch')">
                <div class="page-title-box d-flex align-items-center justify-content-between pb-3">
                    <h4 class="mb-0 font-size-18"></h4>
                    <div class="page-title-right d-block d-lg-block">
                        <button type="button" class="btn-se btn btn-info btn-sm" (click)="isRestorePerusahaan = true">
                            <i class="fa fa-undo font-size-12 align-middle mr-1"></i>
                            {{ 'Aktifkan Perusahaan' | translate }}
                        </button>
                    </div>
                </div>
            </div>


            <div class="row" *ngIf="!isRestorePerusahaan">
                <div class="col-md-6 m-mb-15" *ngFor="let val of listPerusahaan">
                    <div class="card card-perusahaan text-white">
                        <div class="card-body" style="min-height: 150px;">
                            <div class="col-12 p-0">
                                <div style="display: flex; justify-content: flex-end;">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <a href="javascript: void(0);" *ngIf="checkAkses('multiple_branch')"
                                                (click)="deletePerusahaan(val)" class="mb-danger text-white"
                                                placement="top" ngbTooltip="Hapus">
                                                <i class="fa fa-trash font-size-14 align-middle"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div *ngIf="listPerusahaan.length > 1" class="row"
                                (click)="setPerusahaan(val); modal.dismiss('Cross click')"
                                style="cursor: pointer; padding-bottom: 20px;">
                                <div class="col-3 col-md-3 text-center">
                                    <i style="font-size: 3rem;" class="far fa-building"></i>
                                </div>
                                <div class="col-9 col-md-9">
                                    <h5 class="text-white mb-0" style="padding-top: 7.5px !important;">{{ val.nama }}
                                    </h5>
                                    <p class="text-white" style="font-size: 13px;">{{ val.nama_jabatan != undefined &&
                                        val.nama_jabatan != '' ? val.nama_jabatan : '&nbsp;-' }}</p>
                                </div>
                            </div>
                            <div *ngIf="listPerusahaan.length == 1" class="row">
                                <div class="col-2 text-center">
                                    <i style="font-size: 3rem;" class="far fa-building"></i>
                                </div>
                                <div class="col-10">
                                    <h5 class="text-white mb-0" style="padding-top: 7.5px !important;">{{ val.nama }}
                                    </h5>
                                    <p class="text-white" style="font-size: 13px;">{{ val.nama_jabatan != undefined &&
                                        val.nama_jabatan != "" ? val.nama_jabatan : '&nbsp;-' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div *ngIf="checkAkses('multiple_branch')" class="col-md-6 m-mb-15" style="height: 144.149px;"  [routerLink]="['/company/tambah-perusahaan/0']">
                    <div class="card card-perusahaan text-white" style="height: 120.156px; cursor: pointer;">
                        <div class="card-body text-center">
                            <span class="fas fa-plus" style="font-size: 40px; padding-top: 1.3rem;"></span>
                        </div>
                    </div>
                </div> -->
                <div *ngIf="checkAkses('multiple_branch')" class="col-md-6 m-mb-15" style="min-height:150px;"
                    (click)="checkBatasPerusahaan(modal,'/company/tambah-perusahaan/0')">
                    <div class="card card-perusahaan text-white" style="cursor: pointer;">
                        <div class="card-body text-center"
                            style="margin: 0px auto;display: flex;align-items: center;min-height:150px;">
                            <span class="fas fa-plus" style="font-size: 40px;"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="isRestorePerusahaan">
                <div class="col-md-12">
                    <ngb-alert [dismissible]="false" type="info" *ngIf="jumlahPerusahaanModalChecked > 0">
                        <p style="margin-bottom: 0px;"> {{ 'Perusahaan yang akan aktif' | translate }}<span
                                style="font-weight: bold;"> {{jumlahPerusahaanModalChecked}} / {{max_perusahaan}}</span>
                        </p>
                    </ngb-alert>
                </div>
                <div class="col-md-6 m-mb-15" *ngFor="let val of listPerusahaanTerhapus">
                    <div class="card card-perusahaan text-white">
                        <div class="card-body">
                            <div class="col-12 p-0">
                                <div style="display: flex; justify-content: flex-end;">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <div class="custom-control custom-checkbox" style="padding-left: 2.1rem;">
                                                <input [disabled]="!val.check && isCheckPerusahaanDisabled"
                                                    type="checkbox" id="perushaanTerhapus_{{ val.id }}"
                                                    class="custom-control-input" [(ngModel)]="val.check"
                                                    (change)="checkJumlahPerusahaan()" name="check_perusahaan_modal">
                                                <label class="custom-control-label"
                                                    for="perushaanTerhapus_{{ val.id }}"></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div *ngIf="listPerusahaan.length > 1" class="row"
                                (click)="setPerusahaan(val); modal.dismiss('Cross click')"
                                style="cursor: pointer; padding-bottom: 20px;">
                                <div class="col-2 text-center">
                                    <i style="font-size: 3rem;" class="far fa-building"></i>
                                </div>
                                <div class="col-10">
                                    <h5 class="text-white mb-0" style="padding-top: 7.5px !important;">{{ val.nama }}
                                    </h5>
                                    <p class="text-white" style="font-size: 13px;">{{ val.nama_jabatan != undefined &&
                                        val.nama_jabatan != '' ? val.nama_jabatan : '&nbsp;-' }}</p>
                                </div>
                            </div>
                            <div *ngIf="listPerusahaan.length == 1" class="row">
                                <div class="col-2 text-center">
                                    <i style="font-size: 3rem;" class="far fa-building"></i>
                                </div>
                                <div class="col-10">
                                    <h5 class="text-white mb-0" style="padding-top: 7.5px !important;">{{ val.nama }}
                                    </h5>
                                    <p class="text-white" style="font-size: 13px;">{{ val.nama_jabatan != undefined &&
                                        val.nama_jabatan != "" ? val.nama_jabatan : '&nbsp;-' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="modal-footer" *ngIf="isRestorePerusahaan">
        <div class="btn-con justify-content-end">
            <button type="button" class="btn btn-light btn-sm mr-2" (click)="isRestorePerusahaan = false">
                <i class="fa fa-chevron-left font-size-14 align-middle mr-2"></i>
                {{ 'Kembali' | translate }}
            </button>
            <button type="button" class="btn btn-primary btn-sm"
                (click)="restorePerusahaan(); modal.dismiss('Cross click');">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'Restore' | translate }}
            </button>
        </div>
    </div>
</ng-template>
<ng-template #modalGPassword let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'GantiPassword' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row" *ngIf="isAdminPic()">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Username' | translate
                        }}</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="text" [(ngModel)]="model.username"
                            name="username" placeholder="{{ 'Username' | translate }}" />
                    </div>
                </div>
                <!-- <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Password' | translate }}</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="password" [(ngModel)]="model.password" name="password" placeholder="{{ 'Password' | translate }}" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'UlangiPassword' | translate }}</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="password" [(ngModel)]="model.repassword" name="repassword" placeholder="{{ 'UlangiPassword' | translate }}" />
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Password' | translate
                        }}</label>
                    <div class="col-md-8">
                        <div class="input-group input-group-md">
                            <input (keyup)="validatePassword();" class="form-control form-control-sm"
                                [type]="fieldTextTypePassword ? 'text' : 'password'" [(ngModel)]="model.password"
                                name="password" placeholder="{{ 'Password' | translate }}" />
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fa"
                                        [ngClass]="{'fa-eye-slash': !fieldTextTypePassword,'fa-eye': fieldTextTypePassword}"
                                        (click)="toggleFieldTextTypePassword()"
                                        style="cursor: pointer;font-size: x-small;"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12 row mt-1" *ngIf="!model.validasi">
                            <span style="font-style: italic; font-size: x-small; color: #d93025; width: 100%;">
                                {{ model.validasi_error }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'UlangiPassword' | translate
                        }}</label>
                    <div class="col-md-8">
                        <div class="input-group input-group-md">
                            <input class="form-control form-control-sm"
                                [type]="fieldTextTypeUlangiPassword ? 'text' : 'password'"
                                [(ngModel)]="model.repassword" name="repassword"
                                placeholder="{{ 'UlangiPassword' | translate }}" />
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fa"
                                        [ngClass]="{'fa-eye-slash': !fieldTextTypeUlangiPassword,'fa-eye': fieldTextTypeUlangiPassword}"
                                        (click)="toggleFieldTextUlangiPassword()"
                                        style="cursor: pointer; font-size: x-small;"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12 row mt-1"
                            *ngIf="model.repassword != '' && model.repassword != null && model.password != model.repassword">
                            <span style="font-style: italic; font-size: x-small; color: #d93025; width: 100%;">
                                {{ 'Kata sandi itu tidak cocok' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button class="btn btn-primary btn-sm" (click)="savepasswords(0); modal.dismiss('Cross click')"
                [disabled]="model.validasi == false || model.password != model.repassword || model.validasi == false">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'SimpanData' | translate }}
            </button>
        </div>
    </div>
</ng-template>
<ng-template #modalGBahasa let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'Ganti Bahasa' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row" style="padding-left: 18px;padding-right: 18px;">
            <div class="col-md-6 bahasadiv" *ngFor="let language of translate.getLangs()" (click)="switchLang(language)"
                style="text-align: center;padding-top: 20px;padding-bottom: 20px;cursor: pointer;">
                <div class="row">
                    <div class="col-md-12">
                        <img *ngIf="language === 'ENG'" src="assets/images/flags/us.jpg" alt="user-image">
                        <img *ngIf="language === 'IND'" src="assets/images/flags/ind.png" alt="user-image">
                    </div>
                    <div class="col-md-12 mt-2" style="text-align: center;">
                        <span class="align-middle" *ngIf="language === 'ENG'">{{ 'BAHASA INGGRIS' | translate }}</span>
                        <span class="align-middle" *ngIf="language === 'IND'">{{ 'BAHASA INDONESIA' |translate }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #dataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ dataModalPengumuman.judul }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <form>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="media-body">
                                <div class="col-md-12">
                                    <div [innerHTML]="dataModalPengumuman.isi"></div>
                                </div>
                                <div class="col-md-12">
                                    <div style="text-align: end">
                                        <p class="text-muted mb-0 font-weight-bold"><i class="mdi mdi-account mr-1"></i>
                                            {{ dataModalPengumuman.penulis}}, {{dataModalPengumuman.tanggal | date:'d
                                            MMMM y' }} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #settingKaryawanTrial>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 *ngIf="step_pilih_perusahaan_trial == 1" class="modal-title mt-0 text-center" style="color: #fff;">{{
            'Informasi Akun' | translate }}</h5>
        <h5 *ngIf="step_pilih_perusahaan_trial == 2" class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Pilih
            Perusahaan' | translate }}</h5>
        <h5 *ngIf="step_pilih_perusahaan_trial == 3" class="modal-title mt-0 text-center" style="color: #fff;">{{
            'PilihKaryawan' | translate }}</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div *ngIf="step_pilih_perusahaan_trial == 1" class="col-md-12">
                <!-- <div class="row"> -->
                <!-- <ngb-alert [dismissible]="false" type="warning"> -->
                <!-- <span class="text-center">
                            <h4 style="font-weight: bold;">
                                Peringatan 
                            </h4>
                        </span> -->
                <p class="mt-2">Masa aktif kamu sudah berakhir nih, kamu tetap dapat menggunakan layanan akun gratis
                    dengan fitur tertentu, jumlah perusahaan dan karyawan yang terbatas yaitu hanya bisa memilih 1
                    perusahaan dan 10 karyawan. Klik lanjutkan untuk memilih
                    perusahaan yang akan diaktifkan. </p>
                <p class="mt-2"> Fitur yang akan kamu dapat sebagai berikut : </p>
                <div class="col-md-12">
                    <div class="mini-stats-wid">
                        <!-- <div class="card-body"> -->
                        <div class="media">
                            <div class="media-body">
                                <!-- <h5 class="text-black font-weight-medium f-15" style="font-size: 14px; margin-bottom: 1rem;">{{ 'Paket' | translate }} : {{namaPaketModal}}</h5> -->
                                <div class="row">
                                    <div *ngFor="let val of listFiturModal">
                                        <ul class="m-2">
                                            <li *ngFor="let vals of val">
                                                {{ vals.nama }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </div>
                <!-- </ngb-alert> -->
                <!-- </div> -->
            </div>
            <div *ngIf="step_pilih_perusahaan_trial == 2" class="col-md-12">
                <ngb-alert [dismissible]="false" type="warning">
                    <p style="margin-bottom: 0px;">Pilih 1 Perusahaan untuk menentukan karyawan yang ingin tetap aktif.
                    </p>
                </ngb-alert>
                <div class="row">
                    <div class="col-md-6 m-mb-15" *ngFor="let val of listPerusahaan">
                        <div class="card card-perusahaan text-white">
                            <div class="card-body" style="padding-bottom: 0px; ">
                                <div class="row" (click)="pilihPerusahaanTrial(val); step_pilih_perusahaan_trial = 3;"
                                    style="cursor: pointer; padding-bottom: 20px;">
                                    <div class="col-2 text-center">
                                        <i style="font-size: 3rem;" class="far fa-building"></i>
                                    </div>
                                    <div class="col-10">
                                        <h5 class="text-white mb-0" style="padding-top: 7.5px !important;">{{ val.nama
                                            }}</h5>
                                        <p class="text-white pt-1" style="font-size: 13px;">{{ val.total_karyawan }} {{
                                            'Karyawan' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="step_pilih_perusahaan_trial == 3">
                <div class="col-md-12">
                    <ngb-alert [dismissible]="false" type="warning">
                        <p style="margin-bottom: 0px;">{{ 'MasaTrial1' | translate }}<a style="color: #7d5e28;"
                                href="mailto:hello@humanis.id"><strong>hello@humanis.id</strong></a> {{ 'MasaTrial2' |
                            translate }}<strong>+62 (021) 5431 8212</strong> . {{ 'MasaTrial3' | translate }} <strong>{{
                                max_karyawan }} {{ 'Karyawan' | translate }} </strong> {{ 'MasaTrial4' | translate }}
                        </p>
                    </ngb-alert>
                    <div class="form-group row">
                        <div class="col-md-3">
                            <input class="form-control form-control-sm" type="text" bindLabel="nama" bindValue="nama"
                                appendTo="boddy" [(ngModel)]="modalFilter.karyawan_nama"
                                placeholder="Cari berdasarkan Nama">
                        </div>
                        <div class="col-md-3">
                            <ng-select [items]="listJabatan" bindLabel="nama" bindValue="id" name="m_jabatan_id"
                                [(ngModel)]="modalFilter.m_jabatan_id" appendTo="body"
                                placeholder="Pilih Jabatan"></ng-select>
                        </div>
                        <div class="col-md-3">
                            <ng-select appendTo="body" [items]="listOrganisasi" bindLabel="nama" bindValue="id"
                                [(ngModel)]="modalFilter.m_organisasi_id" name="m_organisasi_id"
                                placeholder="Pilih Departemen"></ng-select>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-sm btn-info" (click)="getListKaryawanModal()">
                                <i class="fa fa-search font-size-10 align-middle"></i>
                                &nbsp; {{ 'Cari' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <ngb-alert [dismissible]="false" type="info" *ngIf="jumlahKaryawanModalChecked > 0">
                        <p style="margin-bottom: 0px;"> {{ 'Karyawan terpilih' | translate }}<span
                                style="font-weight: bold;"> {{jumlahKaryawanModalChecked}} / {{max_karyawan}}</span>
                        </p>
                    </ngb-alert>
                </div>
                <div class="col-md-12" style="text-align: center;">
                    <div class="table-responsive">
                        <table class="table table-sm table-hover mobile-optimised">
                            <thead class="bg-primary text-white">
                                <tr>
                                    <th width="10">
                                        <div class="custom-control custom-checkbox" style="padding-left: 2.1rem;">
                                            <input type="checkbox" id="checkAll" class="custom-control-input"
                                                [(ngModel)]="checkAll"
                                                (change)="checkAllKaryawanModal(max_karyawan); checkJumlahKaryawan()"
                                                name="check_all_karyawan_modal">
                                            <label class="custom-control-label" for="checkAll"></label>
                                        </div>
                                    </th>
                                    <th class="text-center" width="20">
                                        {{ 'No' | translate }}
                                    </th>
                                    <th class="text-left">
                                        {{ 'Karyawan' | translate }}
                                    </th>
                                    <th class="text-left">
                                        {{ 'Departemen' | translate }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let val of listKaryawanModal; index as tIndex"
                                    (click)="checkKaryawanModal(val);checkJumlahKaryawan()">
                                    <td>
                                        <div class="custom-control custom-checkbox" style="padding-left: 2.1rem;">
                                            <input [disabled]="true" type="checkbox" id="karawan_modal_{{ val.id }}"
                                                class="custom-control-input" [(ngModel)]="val.check"
                                                name="check_karyawan_modal">
                                            <label class="custom-control-label"
                                                for="karawan_modal_{{ val.id }}"></label>
                                        </div>
                                    </td>
                                    <td class="align-center">{{ tIndex + 1 }}</td>
                                    <td class="align-left"><strong>{{ val.nama }}</strong><br /><small>{{ val.nm_jabatan
                                            }}</small></td>
                                    <td class="align-left">{{ val.nama_organisasi }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="modal-footer" *ngIf="step_pilih_perusahaan_trial == 3">
        <div class="float-right">
            <button class="btn btn-light btn-sm mr-2" (click)="step_pilih_perusahaan_trial = 2;">
                <i class="fa fa-chevron-left font-size-14 align-middle mr-2"></i>
                {{ 'Kembali' | translate }}
            </button>
            <button class="btn btn-primary btn-sm" (click)="saveStatusKaryawan();">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'Simpan' | translate }}
            </button>

        </div>
    </div>
    <div class="modal-footer" *ngIf="step_pilih_perusahaan_trial == 2">
        <div class="float-right">
            <button class="btn btn-light btn-sm mr-2" (click)="openModalSetting()">
                <i class="fa fa-chevron-left font-size-14 align-middle mr-2"></i>
                {{ 'Kembali' | translate }}
            </button>
        </div>
    </div>
    <div class="modal-footer" *ngIf="step_pilih_perusahaan_trial == 1">
        <div class="float-right">
            <button class="btn btn-light btn-sm mr-2" (click)="openModalSetting()">
                <i class="fa fa-chevron-left font-size-14 align-middle mr-2"></i>
                {{ 'Kembali' | translate }}
            </button>
            <button class="btn btn-primary btn-sm mr-2" (click)="step_pilih_perusahaan_trial = 2">
                {{ 'Selanjutnya' | translate }}
                <i class="fa fa-chevron-right font-size-14 align-middle ml-2"></i>
            </button>
        </div>
    </div>
</ng-template>
<ng-template #modalPaketData let-modal>
    <div class="modal-header" style="background: linear-gradient(to left, #685dc7, rgb(34 164 148));">
        <h5 style="color: #fff;" class="modal-title mt-0">{{ 'Paket Anda' | translate }} : {{clientDetail.nama_paket}}
        </h5>
        <button style="color: #fff;" type="button" class="close" (click)="modal.dismiss('Cross click')"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px">
        <div class="row">
            <div class="col-md-12">
                <div class="card" style="margin-bottom: 0px;">
                    <div class="card-body" style="padding: 8px;">
                        <ul ngbNav #customNav="ngbNav" [activeId]="1" class="nav-tabs nav-tabs-custom nav-justified">
                            <li [ngbNavItem]="1">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                                    <span class="d-none d-sm-block">{{ 'Status Membership' | translate }}</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="TabContentpaket"></ng-template>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                                    <span class="d-none d-sm-block">{{ 'Paket Lainnya' | translate }}</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="TabContentpaket1"></ng-template>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="customNav"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" *ngIf="is_tampil_paket" style="display: none;">
                <div class="row">
                    <div *ngFor="let data of listPaket" class="col-xl-4 col-md-6">
                        <div class="card plan-box">
                            <div class="card-body p-4">
                                <div class="media">
                                    <div class="media-body">
                                        <h4>{{ data.nama }}</h4>
                                    </div>
                                </div>
                                <div class="plan-features mt-1">
                                    <div *ngFor="let fitur of data.fitur; index as i">
                                        <div class="pt-2" *ngIf="i < 7 || data.is_lihat_all">
                                            <i class="fa fa-check-square text-primary mr-2"></i> {{ fitur.nama }}
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center plan-btn pt-3">
                                    <a *ngIf="data.is_lihat_all == false" href="javascript: void(0);"
                                        class="btn btn-primary btn-sm position-relative"
                                        (click)="lihatSemuaFitur(data, true)">{{ 'Lihat Selengkapnya' | translate }}</a>
                                    <a *ngIf="data.is_lihat_all" href="javascript: void(0);"
                                        class="btn btn-danger btn-sm position-relative"
                                        (click)="lihatSemuaFitur(data, false)">{{ 'Sembunyikan' | translate }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #settingTipe>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Silahkan Memilih database untuk akun trial
            anda' | translate }}</h5>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div class="col-md-12" (click)="settingInputClient(1, settingTipe)">
                    <div class="card card-perusahaan text-white mb-0">
                        <div class="card-body">
                            <div class="row" style="cursor: pointer;">
                                <div class="col-2 text-center" style="margin: auto;">
                                    <i style="font-size: 3rem;" class="far fa-file-alt"></i>
                                </div>
                                <div class="col-10" style="margin: auto;">
                                    <h5 class="text-white mb-0"
                                        style="padding-top: 7.5px !important; padding-left: 3px;">{{ 'Database Baru' |
                                        translate }}</h5>
                                    <p class="mb-0 pt-2" style="font-size: 10px;">{{ 'Anda harus mengisi data
                                        Perusahaan, Karyawan dan lainnya secata Manual agar sistem dapat berjalan dengan
                                        benar' | translate }}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" (click)="settingInputClient(2, settingTipe)" style="display: none;">
                    <div class="card card-perusahaan text-white mb-0">
                        <div class="card-body">
                            <div class="row" style="cursor: pointer;">
                                <div class="col-2 text-center" style="margin: auto;">
                                    <i style="font-size: 2.6rem;" class="fa fa-file-import"></i>
                                </div>
                                <div class="col-10" style="margin: auto;">
                                    <h5 class="text-white mb-0"
                                        style="padding-top: 7.5px !important; padding-left: 3px;">{{ 'Database Demo' |
                                        translate }}</h5>
                                    <p class="mb-0 pt-2" style="font-size: 10px;">{{ 'Sistem akan membuat data
                                        Perusahaan, Karyawan, Jabtan, Organisasi untuk kebutuhan Demo secara Otomatis' |
                                        translate }}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #modalTutorialAwal let-modal id="modalTutor">
    <div class="modal-tutorial">
        <div class="">
            <h5 class="modal-title mt-0"></h5>
        </div>
        <div class="modal-body p-5 text-center">
            <span style="font-size: 14px;">
                {{ 'Selesaikan Tutorial dasar ini agar Perusahaan anda dapat segera menggunakan semua Fitur .'|
                translate }}
            </span>
        </div>
        <div class="p-3 modal-footer-tutorial">
            <div class="col-md-12">
                <div class=" row">
                    <div class="col-md-6 p-0 text-left">
                        <button class=" btn-modal-tutorial" (click)="LewatiTutorial(); modal.dismiss('Cross click')">
                            <i class="fa fa-times font-size-14 align-middle mr-2"></i>
                            {{ 'Lewati' | translate }}
                        </button>
                    </div>
                    <div class="col-md-6 p-0 text-right">
                        <button class=" btn-modal-tutorial"
                            (click)="setTutorialSettingAwal(); modal.dismiss('Cross click')">
                            <i class="fa fa-check font-size-14 align-middle mr-2"></i>
                            {{ 'Lanjutkan' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- Tab Content -->
<ng-template #TabContentpaket>
    <div class="alert alert-info mt-4">
        <p class="text-muted mb-0">Untuk mengubah paket berlangganan silahkan menghubungi tim markeeting kami melalui
            email : <a href="mailto:hello@humanis.id">hello@humanis.id</a></p>
    </div>
    <table class="table table-nowrap mb-0">
        <tbody>
            <tr>
                <th scope="row" style="width: 10%">{{ 'Nama' | translate }}</th>
                <td style="width: 40%">: {{clientDetail.nama}}</td>
                <th scope="row" style="width: 10%">Jenis Usaha</th>
                <td style="width: 40%">: {{ clientDetail.jenis_usaha }}</td>
            </tr>
            <tr>
                <th scope="row">Email</th>
                <td>: {{ clientDetail.email }}</td>
                <th scope="row">Jatuh Tempo</th>
                <td>: {{ clientDetail.tgl_aktif }}</td>
            </tr>
        </tbody>
    </table>
    <div class="div-b-table-klien mt-2">
        <table class="custom-table-klien table table-hover">
            <thead class="thead-light">
                <tr style="background: #564ab1; color: #fff;">
                    <th width="25" class="text-center" style="background: #564ab1 !important; color: #fff;">
                        No.
                    </th>
                    <th class="text-center" style="background: #564ab1 !important; color: #fff;">
                        {{ 'Nama Perusahaan' | translate }}
                    </th>
                    <th class="text-center" width="120" style="background: #564ab1 !important; color: #fff;">
                        {{ 'Karyawan' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let val of listModalpaket; index as tIndex">
                    <td class="align-center">{{ tIndex + 1 }}</td>
                    <td>{{ val.nm_perusahaan }}</td>
                    <td class="align-center">{{ val.total | number}} / {{ clientDetail.max_karyawan | number }}</td>
                </tr>
            </tbody>
            <tfoot class="thead-light">
                <tr>
                    <th colspan="2" class="text-right" style="background: #564ab1 !important; color: #fff;"><b>Total</b>
                    </th>
                    <th class="align-center" style="background: #564ab1 !important; color: #fff;"><b>{{
                            listJumlahKaryawan | number}}/{{clientDetail.allmaxkaryawan | number}}</b></th>
                </tr>
            </tfoot>
        </table>
    </div>
</ng-template>
<ng-template #TabContentpaket1>
    <div class="col-12 mt-2" style="padding-left: 0px;padding-right: 0px;">
        <div class="table-wrapper div-b-table ct" style="border: none !important; box-shadow: none;">
            <table class="custom-table table table-responsive ct-table" style="max-height: 600px;">
                <thead>
                    <tr>
                        <th class="text-left ct-sticky " style="max-width:450px;width: 450px !important;left: 0;
                        z-index: 99; background: #564ab1 !important; color: #fff;text-align: center !important;"
                            colspan="2">
                            <h6 style="color: #fff;text-transform: uppercase;">{{ 'Fitur yang tersedia' | translate }}
                            </h6>
                        </th>
                        <th class="ct-sticky ct-sticky-paket" *ngFor="let data of listPaket"
                            style="background: #564ab1 !important; color: #fff;">
                            <h6 style="color: #fff">{{ data.nama }}</h6>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let val of listFitur">
                        <tr>
                            <th [attr.rowspan]="val.rowspan" class="border-right listfiturnya"
                                style="font-size: 10px;vertical-align: middle;text-align: center;">
                                {{ val.nama_kategori }}
                            </th>
                            <td style="text-align: left;font-size: 10px;padding: 13px;vertical-align: middle;">
                                <span *ngIf="translate.currentLang == 'IND'">{{ val.index.nama_ind }}</span>
                                <span *ngIf="translate.currentLang == 'ENG'">{{ val.index.nama }}</span>
                            </td>
                            <td style="font-size: 15px;text-align: center;vertical-align: middle;"
                                *ngFor="let valz of val.index.paket">
                                <i class="fas fa-check-circle" style="color: #2CC196;" *ngIf="valz.check == true"></i>
                            </td>
                        </tr>
                        <tr *ngFor="let data of val.detail">
                            <td style="text-align: left;font-size: 10px;padding: 13px;vertical-align: middle;">
                                <span *ngIf="translate.currentLang == 'IND'">{{ data.nama_ind }}</span>
                                <span *ngIf="translate.currentLang == 'ENG'">{{ data.nama }}</span>
                            </td>
                            <td style="font-size: 15px;text-align: center;vertical-align: middle;"
                                *ngFor="let valz of data.paket">
                                <i class="fas fa-check-circle" style="color: #2CC196;" *ngIf="valz.check == true"></i>
                            </td>
                        </tr>
                    </ng-container>
                    <tr>
                        <th class="border-right" style="font-size: 0.8125rem;">
                        </th>
                        <th class="border-right" style="font-size: 0.8125rem;">
                        </th>
                        <td style="font-size: 12px;text-align: center;" *ngFor="let data of listPaket">
                            <a target="_blank" href="mailto:hello@humanis.id" class="btn btn-sm btn-default"
                                style="background-color: #2CC196; color: #fff">{{ 'Pesan Sekarang' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>

<ng-template #modalGPasswordVerifiedEmail let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'GantiPassword' | translate }}</h5>
        <!-- <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button> -->
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <!-- <div class="form-group row" *ngIf="isAdminPic()">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Username' | translate }}</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="text" [(ngModel)]="model.username" name="username" placeholder="{{ 'Username' | translate }}" />
                    </div>
                </div> -->
                <!-- <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Password' | translate }}</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="password" [(ngModel)]="model.password" name="password" placeholder="{{ 'Password' | translate }}" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'UlangiPassword' | translate }}</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="password" [(ngModel)]="model.repassword" name="repassword" placeholder="{{ 'UlangiPassword' | translate }}" />
                    </div>
                </div> -->
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Password' | translate
                        }}</label>
                    <div class="col-md-8">
                        <div class="input-group input-group-md">
                            <input (keyup)="validatePassword();" class="form-control form-control-sm"
                                [type]="fieldTextTypePassword ? 'text' : 'password'" [(ngModel)]="model.password"
                                name="password" placeholder="{{ 'Password' | translate }}" />
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fa"
                                        [ngClass]="{'fa-eye-slash': !fieldTextTypePassword,'fa-eye': fieldTextTypePassword}"
                                        (click)="toggleFieldTextTypePassword()"
                                        style="cursor: pointer;font-size: x-small;"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12 row mt-1" *ngIf="!model.validasi">
                            <span style="font-style: italic; font-size: x-small; color: #d93025; width: 100%;">
                                {{ model.validasi_error }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'UlangiPassword' | translate
                        }}</label>
                    <div class="col-md-8">
                        <div class="input-group input-group-md">
                            <input class="form-control form-control-sm"
                                [type]="fieldTextTypeUlangiPassword ? 'text' : 'password'"
                                [(ngModel)]="model.repassword" name="repassword"
                                placeholder="{{ 'UlangiPassword' | translate }}" />
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fa"
                                        [ngClass]="{'fa-eye-slash': !fieldTextTypeUlangiPassword,'fa-eye': fieldTextTypeUlangiPassword}"
                                        (click)="toggleFieldTextUlangiPassword()"
                                        style="cursor: pointer; font-size: x-small;"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-12 row mt-1"
                            *ngIf="model.repassword != '' && model.repassword != null && model.password != model.repassword">
                            <span style="font-style: italic; font-size: x-small; color: #d93025; width: 100%;">
                                {{ 'Kata sandi itu tidak cocok' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button class="btn btn-primary btn-sm" (click)="savepasswords(1); modal.dismiss('Cross click')"
                [disabled]="model.password != model.repassword">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'SimpanData' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #settingAkun let-modal>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Pengingat!' | translate }}
        </h5>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div *ngIf="!checkAkses('invoice') && tipe_setting_invoice == 1">
                    <div class="col-md-12" style="padding: 0px;">
                        <ngb-alert [dismissible]="false" type="info">
                            <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Masa kontrak
                                kamu telah berakhir nih !!' | translate}}</p>
                            <p style="margin-bottom: 0px;">
                                {{'Silahkan hubungi admin perusahaan anda untuk memperpanjang masa aktif, agar dapat
                                kembali menggunakan fitur ' | translate}}
                            </p>
                        </ngb-alert>
                    </div>
                </div>
                <div
                    *ngIf="((checkAkses('invoice') || is_session_admin_invoice) && tipe_setting_invoice == 2 && is_setting_invoice_terisi) || clientDetail.is_paket_custom">
                    <div class="col-md-12 text-center">
                        <ngb-alert [dismissible]="false" type="info">
                            <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, Masa kontrak
                                kamu telah berakhir' | translate}}</p>
                            <p style="margin-bottom: 0px;">
                                {{'Silahkan Perpanjang kontrak anda untuk tetap bisa menggunakan fitur ' | translate}}
                            </p>
                        </ngb-alert>
                        <button (click)="checkInvoicePendingAktif(); modal.dismiss('Cross click')"
                            style="height: 30px; vertical-align: middle; width: 100%;" type="button"
                            class="btn btn-info btn-sm">
                            {{'Perpanjang Kontrak' | translate}}
                        </button>
                    </div>
                </div>
                <div
                    *ngIf="((checkAkses('invoice') && tipe_setting_invoice == 1) || ((checkAkses('invoice') || (is_session_admin_invoice && tipe_setting_invoice == 2))) && !is_setting_invoice_terisi) && !clientDetail.is_paket_custom">
                    <div class="col-md-12" style="padding: 0px;">
                        <ngb-alert [dismissible]="false" type="warning">
                            <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Masa kontrak
                                kamu telah berakhir nih !!' | translate}}</p>
                            <p style="margin-bottom: 0px;">
                                {{'Silahkan melakukan pembelian paket agar kamu tetap dapat menggunakan akun' |
                                translate}}
                            </p>
                        </ngb-alert>
                    </div>
                    <div class="col-12 mt-2" style="padding-left: 0px;padding-right: 0px;">
                        <a href="https://wa.me/62085177547758?text=Halo%20Admin%2C%20saya%20ingin%20memperpanjang%20paket%20Humanis"
                            target="_blank" class="btn btn-success btn-block"
                            style="background-color: #25D366; border-color: #25D366;">
                            <i class="fab fa-whatsapp font-size-16 align-middle mr-2"></i>
                            {{ 'Hubungi Admin Humanis' | translate }}
                        </a>
                    </div>
                    <div class="col-12 mt-2" style="padding-left: 0px;padding-right: 0px; display: none;"
                        *ngIf="listFitur.length > 0">
                        <div class="table-wrapper div-b-table ct" style="border: none !important; box-shadow: none;">
                            <table class="custom-table table table-responsive ct-table" style="max-height: 500px;">
                                <thead>
                                    <tr>
                                        <th class="text-left ct-sticky "
                                            style="left: 0;z-index: 99; text-align: center !important; width: 400px;">
                                            <h5 style="text-transform: uppercase; font-weight: bold;">{{'Fitur' |
                                                translate}}</h5>
                                        </th>
                                        <th class="ct-sticky ct-sticky-paket" *ngFor="let data of listPaket"
                                            style="z-index: 99;width: 18% !important; padding: 7px !important;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <a (click)="modal.dismiss('Cross click'); pengaturanAkun(1,data);"
                                                        role="button" *ngIf="data.nama != 'FREE'"
                                                        class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; padding: 7px; width: 120px; border-radius: 6px;">{{data.nama}}
                                                    </a>
                                                    <a (click)="modal.dismiss('Cross click'); pengaturanAkun(0,data);"
                                                        role="button" *ngIf="data.nama == 'FREE'"
                                                        class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; padding: 7px; width: 120px; border-radius: 6px;"
                                                        [ngStyle]="{'margin-bottom': data.potongan_promo ? '76px' : '24px'}">{{data.nama}}</a>
                                                </div>
                                                <div class="col-md-12 mt-1">
                                                    <span *ngIf="data.nama != 'FREE' && data.potongan_promo == 0"
                                                        style="font-size: 11px; font-weight: lighter; padding-top: 7px;">
                                                        Rp.{{data.tarif_per_karyawan | number}} / Karyawan
                                                    </span>
                                                    <span *ngIf="data.nama != 'FREE' && data.potongan_promo != 0"
                                                        style="font-size: 11px; font-weight: lighter; padding-top: 7px;">
                                                        <span class="mt-1 font-size-11">
                                                            <small class="font-gray">Rp.</small>
                                                            <span style='color:red;text-decoration:line-through'>
                                                                <span class="font-gray">
                                                                    {{data.tarif_asli | number}}
                                                                </span>
                                                            </span>
                                                            <span class="font-gray">/{{' Karyawan'| translate}}</span>
                                                        </span>
                                                        <br>
                                                        <span style="font-weight: bold;" class="font-size-12">
                                                            Rp.{{data.tarif_promo | number}} / {{' Karyawan'|
                                                            translate}}
                                                        </span>
                                                        <br>
                                                        <span class="font-size-10">
                                                            {{'(S&K berlaku)' | translate}}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- <br> -->
                                            <!-- <span *ngIf="data.nama == 'FREE'" style="font-size: 11px; font-weight: lighter; padding-top: 5px; display: none;">
                                               Rp. 0 / Karyawan
                                            </span> -->
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>
                                                {{'UNLIMITED KARYAWAN' | translate}}
                                            </span>
                                        </td>
                                        <td style="font-size: 12px;text-align: center;vertical-align: middle;">
                                            <span class="badge badge-danger" style="border-radius: 30px; width: 17px;">
                                                10</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>
                                                {{'UNLIMITED PERUSAHAAN' | translate}}
                                            </span>
                                        </td>
                                        <td style="font-size: 12px;text-align: center;vertical-align: middle;">
                                            <span class="badge badge-danger" style="border-radius: 30px; width: 17px;">
                                                1</span>
                                        </td>
                                        <td style="font-size: 12px;text-align: center;vertical-align: middle;">
                                            <span class="badge badge-danger" style="border-radius: 30px; width: 17px;">
                                                1</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <ng-container *ngFor="let val of listFitur">
                                        <!-- <tr>
                                            <th [attr.rowspan]="val.rowspan" class="border-right listfiturnya" style="font-size: 12px;vertical-align: middle;text-align: center;">
                                                {{ val.nama_kategori }}
                                            </th>
                                            <td style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                                <span *ngIf="translate.currentLang == 'IND'">{{ val.index.nama_ind}}</span>
                                                <span *ngIf="translate.currentLang == 'ENG'">{{ val.index.nama}}</span>
                                            </td>
                                            <td style="font-size: 17px;text-align: center;vertical-align: middle;" *ngFor="let valz of val.index.paket">
                                                <i class="fas fa-check-circle" style="color: #2CC196;" *ngIf="valz.check == true"></i>
                                            </td>
                                        </tr> -->
                                        <tr>
                                            <td [attr.colspan]="listPaket.length + 1" class="border-right listfiturnya"
                                                style="font-size: 13px; font-weight: bold;padding: 13px;">
                                                {{ val.nama_kategori }}
                                            </td>
                                        </tr>
                                        <tr *ngFor="let data of val.detail">
                                            <td
                                                style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                                <span *ngIf="translate.currentLang == 'IND'">{{ data.nama_ind}}</span>
                                                <span *ngIf="translate.currentLang == 'ENG'">{{ data.nama}}</span>
                                            </td>
                                            <td style="font-size: 17px;text-align: center;vertical-align: middle;"
                                                *ngFor="let valz of data.paket">
                                                <i class="fas fa-check-circle" style="color: #2CC196;"
                                                    *ngIf="valz.check == true"></i>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <!-- <tr>
                                        <th class="border-right" style="font-size: 0.8125rem;">
                                        </th>
                                        <td style="font-size: 12px;text-align: center;" *ngFor="let data of listPaket">
                                            <a (click)="modal.dismiss('Cross click'); pengaturanAkun(1,data);" role="button" *ngIf="data.nama != 'FREE'" class="btn btn-sm btn-default" style="background-color: #2CC196; color: #fff">{{ 'Mulai berlangganan' | translate}}</a>
                                            <a (click)="modal.dismiss('Cross click'); pengaturanAkun(0,data);" role="button" *ngIf="data.nama == 'FREE'" class="btn btn-sm btn-default" style="background-color: #2CC196; color: #fff">{{ 'Gunakan Akun gratis' | translate}}</a>
                                        </td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #settingAkunBaru let-modal>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Masa kontrak Kamu telah habis' | translate }}
        </h5>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div style="width: 100%" *ngIf="!checkAkses('invoice') && tipe_setting_invoice == 1">
                    <div class="col-md-12">
                        <ngb-alert [dismissible]="false" type="info">
                            <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, Masa kontrak
                                kamu telah berakhir nih !!' | translate}}</p>
                            <p style="margin-bottom: 0px;">
                                {{'Silahkan hubungi admin perusahaan anda untuk memperpanjang masa aktif, agar dapat
                                kembali menggunakan fitur ' | translate}}
                            </p>
                        </ngb-alert>
                    </div>
                </div>
                <div style="width: 100%"
                    *ngIf="((checkAkses('invoice') || is_session_admin_invoice) && tipe_setting_invoice == 2 && is_setting_invoice_terisi) || clientDetail.is_paket_custom">
                    <div class="col-md-12 text-center">
                        <ngb-alert [dismissible]="false" type="info">
                            <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, Masa kontrak
                                kamu telah berakhir' | translate}}</p>
                            <p style="margin-bottom: 0px;">
                                {{'Silahkan Perpanjang kontrak anda untuk tetap bisa menggunakan fitur ' | translate}}
                            </p>
                        </ngb-alert>
                        <button (click)="checkInvoicePendingAktif(); modal.dismiss('Cross click')"
                            style="height: 30px; vertical-align: middle; width: 100%;" type="button"
                            class="btn btn-info btn-sm">
                            {{'Perpanjang Kontrak' | translate}}
                        </button>
                    </div>
                </div>
                <div style="width: 100%"
                    *ngIf="((checkAkses('invoice') && tipe_setting_invoice == 1) || ((checkAkses('invoice') || (is_session_admin_invoice && tipe_setting_invoice == 2))) && !is_setting_invoice_terisi) && !clientDetail.is_paket_custom">
                    <div class="col-md-12">
                        <ngb-alert [dismissible]="false" type="warning">
                            <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, Masa kontrak
                                kamu telah berakhir nih !!' | translate}}</p>
                            <p style="margin-bottom: 0px;">
                                {{'aaaaSilahkan melakukan pembelian paket atau kamu tetap dapat menggunakan akun free
                                dengan
                                fitur yang terbatas.' | translate}}
                            </p>
                        </ngb-alert>
                    </div>
                    <div class="col-12 mt-2" style="padding-left: 0px;padding-right: 0px;" *ngIf="listFitur.length > 0">
                        <div class="table-wrapper div-b-table ct" style="border: none !important; box-shadow: none;">
                            <table class="custom-table table table-responsive ct-table" style="max-height: 500px;">
                                <thead>
                                    <tr>
                                        <th class="text-left ct-sticky "
                                            style="left: 0;z-index: 99; text-align: center !important; width: 17% !important;">
                                            <h5 style="text-transform: uppercase; font-weight: bold;">{{'Fitur' |
                                                translate}}</h5>
                                        </th>
                                        <th class="ct-sticky ct-sticky-paket"
                                            style="z-index: 99;width: 17% !important; padding: 7px !important;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <a role="button" class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; height: 44px !important; border-radius: 6px;">
                                                        {{'Free' | translate}}
                                                    </a>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="ct-sticky ct-sticky-paket"
                                            style="z-index: 99;width: 17% !important; padding: 7px !important;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <a role="button" class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; height: 44px !important; border-radius: 6px;">
                                                        {{'Presensi' | translate}}
                                                    </a>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="ct-sticky ct-sticky-paket"
                                            style="z-index: 99;width: 17% !important; padding: 7px !important;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <a role="button" class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; height: 44px !important; border-radius: 6px;">
                                                        {{'Payroll' | translate}}
                                                    </a>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="ct-sticky ct-sticky-paket"
                                            style="z-index: 99;width: 32% !important; padding: 7px !important;">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <a role="button" class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; height: 44px !important; border-radius: 6px;">
                                                        {{'Presensi & Payroll' | translate}}
                                                    </a>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>
                                                {{'UNLIMITED KARYAWAN' | translate}}
                                            </span>
                                        </td>
                                        <td style="font-size: 12px;text-align: center;vertical-align: middle;">
                                            <span class="badge badge-danger" style="border-radius: 30px; width: 17px;">
                                                10</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>
                                                {{'UNLIMITED PERUSAHAAN' | translate}}
                                            </span>
                                        </td>
                                        <td style="font-size: 12px;text-align: center;vertical-align: middle;">
                                            <span class="badge badge-danger" style="border-radius: 30px; width: 17px;">
                                                1</span>
                                        </td>
                                        <td style="font-size: 12px;text-align: center;vertical-align: middle;">
                                            <span class="badge badge-danger" style="border-radius: 30px; width: 17px;">
                                                1</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>

                                    <!-- ====================== DATA KARYAWAN ====================== -->
                                    <tr>
                                        <td colspan="5" class="border-right listfiturnya"
                                            style="font-size: 13px; font-weight: bold;padding: 13px;">
                                            {{ 'Data Karyawan' | translate }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Data Karyawan' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Hak Akses' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Pengaturan Perusahaan' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Multi Language' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Multiple Perusahaan' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Memo' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Saran dan Masukan' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                            <span>{{ 'Laporan Karyawan' | translate }}</span>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>

                                    <!-- ====================== ABSENSI & JADWAL KERJA ====================== -->
                                    <tr>
                                        <td colspan="5" class="border-right listfiturnya"
                                            style="font-size: 13px; font-weight: bold;padding: 13px;">
                                            {{ 'Absensi & Jadwal Kerja' | translate }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Check clock' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Izin' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Jadwal Kerja' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Lembur' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Laporan' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>

                                    <!-- ====================== PAYROLL MANAGEMENT ====================== -->
                                    <tr>
                                        <td colspan="5" class="border-right listfiturnya"
                                            style="font-size: 13px; font-weight: bold;padding: 13px;">
                                            {{ 'Payroll Management' | translate }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Penggajian' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Laporan Penggajian' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Pinjaman & Bayar Pinjaman' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Reimbursement' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>

                                    <!-- ====================== RECRUITMENT ====================== -->
                                    <tr>
                                        <td colspan="5" class="border-right listfiturnya"
                                            style="font-size: 13px; font-weight: bold;padding: 13px;">
                                            {{ 'Recruitment' | translate }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Custom form screening kandidat' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Embed form ke website perusahaan' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Manajemen seleksi kandidat (shortlist, proses, interview, hired)' |
                                            translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Email otomatis ke kandidat sesuai tahap seleksi' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Karyawan diterima otomatis masuk sistem' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Bookmark candidate jika dibutuhkan' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="font-size:12px;padding:13px;">
                                            {{ 'Setting custom approval line' | translate }}
                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">

                                        </td>
                                        <td style="font-size: 17px;text-align: center;vertical-align: middle;">
                                            <i class="fas fa-check-circle" style="color: #2CC196;"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #reminderMasaAktif let-modal>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Reminder Masa Aktif' | translate }}</h5>
        <button style="color: #fff;" type="button" class="close"
            (click)="modal.dismiss('Cross click');saveReminderMasaAktifLocal();" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-center">
                        <div class="avatar-md mx-auto mb-2">
                            <div class="avatar-title bg-light rounded-circle text-primary h1">
                                <i class="fas fa-envelope-open-text mb-2 mt-2"></i>
                            </div>
                        </div>
                        <h4>
                            {{ 'Paket Anda akan berakhir dalam' | translate }} {{sisa_masa_aktif}} {{ 'Hari' | translate
                            }}
                        </h4>
                        <h6 class="m-3" *ngIf="!checkAkses('invoice')">
                            {{ 'Pastikan perpanjang sebelum masa aktif habis' | translate }}
                        </h6>
                        <div *ngIf="checkAkses('invoice')">
                            <h6 class="m-3">
                                {{ 'Silahkan klik tombol dibawah untuk memperpanjang paket sebelum masa aktif anda
                                berakhir' | translate }}
                            </h6>

                            <!-- <button *ngIf="clientDetail.status != 2"
                                style="height: 30px; vertical-align: middle; width: 70%;" type="button"
                                class="btn btn-info btn-sm"
                                (click)="modal.dismiss('Cross click');saveReminderMasaAktifLocal();checkInvoicePendingReminder();">
                                {{ 'Perpanjang Paket' | translate }}
                            </button> -->

                            <a href="https://wa.me/62085177547758?text=Halo%20Admin%2C%20saya%20ingin%20memperpanjang%20paket%20Humanis"
                                target="_blank" class="btn btn-success"
                                style="background-color: #25D366; border-color: #25D366; width: 70%;">
                                <i class="fab fa-whatsapp font-size-16 align-middle mr-2"></i>
                                {{ 'Hubungi Admin Humanis' | translate }}
                            </a>
                            <!-- KHUSUS UNTUK CLIENT DEMO -->
                            <div class="col-12 pt-4" style="padding-left: 0px;padding-right: 0px;display: none;"
                                *ngIf="listFitur.length > 0 && clientDetail.status == 2">
                                <div class="table-wrapper div-b-table ct"
                                    style="border: none !important; box-shadow: none;">
                                    <table class="custom-table table table-responsive ct-table"
                                        style="max-height: 500px;">
                                        <thead>
                                            <tr>
                                                <th class="text-left ct-sticky "
                                                    style="left: 0;z-index: 99; text-align: center !important; width: 400px;">
                                                    <h5 style="text-transform: uppercase; font-weight: bold;">{{ 'Fitur'
                                                        | translate }}</h5>
                                                </th>
                                                <th class="ct-sticky ct-sticky-paket" *ngFor="let data of listPaket"
                                                    style="z-index: 99;width: 18% !important; padding: 7px !important;">
                                                    <a (click)="modal.dismiss('Cross click');saveReminderMasaAktifLocal(); pengaturanAkun(1,data);"
                                                        role="button" class="btn btn-primary btn-sm btn-default"
                                                        style="font-size: large; padding: 7px; width: 120px; border-radius: 6px; margin-bottom: 25px;">{{
                                                        data.nama }}</a>
                                                    <br>
                                                    <span
                                                        style="font-size: 11px; font-weight: lighter; padding-top: 5px;">
                                                        Rp.{{ data.tarif_per_karyawan | number }} / {{'Karyawan' |
                                                        translate}}
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let val of listFitur">
                                                <tr>
                                                    <td [attr.colspan]="listPaket.length + 1"
                                                        class="border-right listfiturnya"
                                                        style="font-size: 13px; font-weight: bold;padding: 13px;">
                                                        {{ val.nama_kategori }}
                                                    </td>
                                                </tr>
                                                <tr *ngFor="let data of val.detail">
                                                    <td
                                                        style="text-align: left;font-size: 12px;padding: 13px;vertical-align: middle;">
                                                        <span *ngIf="translate.currentLang == 'IND'">{{ data.nama_ind
                                                            }}</span>
                                                        <span *ngIf="translate.currentLang == 'ENG'">{{ data.nama
                                                            }}</span>
                                                    </td>
                                                    <td style="font-size: 17px;text-align: center;vertical-align: middle;"
                                                        *ngFor="let valz of data.paket">
                                                        <i class="fas fa-check-circle" style="color: #2CC196;"
                                                            *ngIf="valz.check == true"></i>
                                                    </td>
                                                </tr>
                                            </ng-container>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #modalPerpanjang let-modal>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Upgrade kontrak' | translate}}</h5>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div class="col-md-12 text-center">
                    <ngb-alert [dismissible]="false" type="info">
                        <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, terdapat perubahan
                            pengaturan kontrak untuk masa kontrak kamu saat ini' | translate}}</p>
                        <p style="margin-bottom: 0px;">
                            {{'Silahkan upgrade kontrak anda untuk tetap bisa menggunakan fitur ' | translate}}
                        </p>
                    </ngb-alert>
                    <button (click)="perpanjangKontrakInvoiceBranch()"
                        style="height: 30px; vertical-align: middle; width: 100%;" type="button"
                        class="btn btn-info btn-sm" (click)="modal.dismiss('Cross click');">
                        {{'Upgrade kontrak' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #reminderInvoicePending let-modal>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Reminder invoice' | translate}}</h5>
        <button style="color: #fff;" type="button" class="close"
            (click)="modal.dismiss('Cross click');saveReminderInvoicePendingLocal();" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div class="col-md-12 text-center">
                    <ngb-alert [dismissible]="false" type="info">
                        <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, ada invoice yang
                            belum kamu selesaikan' | translate}}</p>
                        <p style="margin-bottom: 0px;">
                            {{'Silahkan selesaikan invoice yang sudah kamu buat agar mendapatkan fitur yang lebih
                            banyak' | translate}}
                        </p>
                    </ngb-alert>
                    <button (click)="perpanjangKontrakInvoiceBranch();saveReminderInvoicePendingLocal();"
                        style="height: 30px; vertical-align: middle; width: 100%;" type="button"
                        class="btn btn-info btn-sm" (click)="modal.dismiss('Cross click');">
                        {{'Pergi ke halaman invoice' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #modalPerpanjangInvoicePending let-modal>
    <div class="modal-header" style="background-color: #4E51A2; color: #fff;">
        <h5 class="modal-title mt-0 text-center" style="color: #fff;">{{ 'Perpanjang Invoice' | translate}}</h5>
    </div>
    <div class="modal-body">
        <div class="container" style="padding: 12px;">
            <div class="row">
                <div class="col-md-12 text-center">
                    <ngb-alert [dismissible]="false" type="info">
                        <p style="margin-bottom: 5px; font-size: large; font-weight: bold;">{{ 'Oops, terdapat Invoice
                            Pending yang belum dibayar' | translate}}</p>
                        <p style="margin-bottom: 0px;">
                            {{'Silahkan upgrade kontrak anda untuk tetap bisa menggunakan fitur ' | translate}}
                        </p>
                    </ngb-alert>
                    <button (click)="perpanjangInvoice();modal.dismiss('Cross click');"
                        style="height: 30px; vertical-align: middle; width: 100%;" type="button"
                        class="btn btn-info btn-sm">
                        {{'ke halaman Invoice' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>



<ng-template #modalTwoAuth let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'Two Authentication' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm">{{ 'Enable 2FA' | translate }}</label>
                    <div class="col-md-8">
                        <div class="btn-group-sm btn-group-toggle" ngbRadioGroup name="radioBasic"
                            [(ngModel)]="model.twofa">
                            <label ngbButtonLabel class="btn-sm btn-primary m-mb-15">
                                <i class="fa fa-check" *ngIf="model.twofa == 1"></i>
                                <input ngbButton type="radio" [value]="1"> {{ 'Aktif' | translate }}
                            </label>
                            <label ngbButtonLabel class="btn-sm btn-primary">
                                <i class="fa fa-check" *ngIf="model.twofa == 0"></i>
                                <input ngbButton type="radio" [value]="0"> {{ 'Non Aktif' | translate }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button class="btn btn-primary btn-sm" (click)="savetwoauth(model);">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'Simpan' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #confirmKey let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'Two Authentication' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="alert alert-info" role="alert" style="margin-bottom: 20px;">
                    Silahkan scan kode berikut pada aplikasi Google Authenticator dan konfirmasi kode untuk melanjutkan
                    proses Two Factor Authentication
                </div>
            </div>
            <div class="col-md-12" style="text-align: center;">
                <img src="{{qrcode}}" alt="QR Auth">
            </div>
            <!-- <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-8 offset-md-2">
                        <input class="form-control form-control-md" type="text" [(ngModel)]="fa_qr" name="fa_qr" placeholder="{{ 'Konfirmasi Kode' | translate }}" />
                    </div>
                </div>
            </div> -->
            <div class="col-md-12 pl-4 pr-4">
                <div class="pb-3">
                    {{ 'Konfirmasi Kode' | translate }}
                </div>
                <div class="form-group row">
                    <div class="col-md-2">
                        <input class="form-control form-control-lg" type="text" [maxlength]="1" [(ngModel)]="faqr1"
                            name="faqr1" id="faqr1" style="text-align: center;" (input)="setFa(1)" />
                    </div>
                    <div class="col-md-2">
                        <input class="form-control form-control-lg" type="text" [maxlength]="1" [(ngModel)]="faqr2"
                            name="faqr2" id="faqr2" style="text-align: center;" (input)="setFa(2)" />
                    </div>
                    <div class="col-md-2">
                        <input class="form-control form-control-lg" type="text" [maxlength]="1" [(ngModel)]="faqr3"
                            name="faqr3" id="faqr3" style="text-align: center;" (input)="setFa(3)" />
                    </div>
                    <div class="col-md-2">
                        <input class="form-control form-control-lg" type="text" [maxlength]="1" [(ngModel)]="faqr4"
                            name="faqr4" id="faqr4" style="text-align: center;" (input)="setFa(4)" />
                    </div>
                    <div class="col-md-2">
                        <input class="form-control form-control-lg" type="text" [maxlength]="1" [(ngModel)]="faqr5"
                            name="faqr5" id="faqr5" style="text-align: center;" (input)="setFa(5)" />
                    </div>
                    <div class="col-md-2">
                        <input class="form-control form-control-lg" type="text" [maxlength]="1" [(ngModel)]="faqr6"
                            name="faqr6" id="faqr6" style="text-align: center;" (input)="setFa(6)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button class="btn btn-primary btn-sm" (click)="checkauth(faqr1+faqr2+faqr3+faqr4+faqr5+faqr6);">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'Konfirmasi' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #discardKey let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'Two Authentication' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="alert alert-info" role="alert" style="margin-bottom: 20px;">
                    Silahkan konfirmasi kode yang ada pada Google Authenticator untuk menonaktifkan proses Two Factor
                    Authentication
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-8 offset-md-2">
                        <input class="form-control form-control-md" type="text" [(ngModel)]="fa_qr" name="fa_qr"
                            placeholder="{{ 'Konfirmasi Kode' | translate }}" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button class="btn btn-primary btn-sm" (click)="checkauth(fa_qr);">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                {{ 'Konfirmasi' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<!-- ============ CONNECT CHANNEL (WhatsApp) ============ -->
<ng-template #modalConnectChannel let-modal>
    <!-- Section: daftar konteks chat yang dapat dibalas AI Agent (dipakai di step QR & info) -->
    <ng-template #agentContextSection>
        <div class="text-left">
            <h6 class="font-weight-bold mb-1">{{ 'Konteks yang Dapat Dibalas Agent' | translate }}</h6>
            <small class="text-muted d-block mb-2">
                {{ 'Ditangani oleh' | translate }} {{ (connectModel && connectModel.aiAgent) || 'Humanis Agent' }}
            </small>
            <div class="list-group" style="max-height: 380px; overflow-y: auto;">
                <div class="list-group-item px-2 py-2" *ngFor="let ctx of agentContexts">
                    <div class="d-flex align-items-center" style="cursor: pointer;"
                        (click)="ctx.expanded = !ctx.expanded">
                        <div class="flex-grow-1 font-weight-medium font-size-13">{{ ctx.title | translate }}</div>
                        <i class="fas" [ngClass]="ctx.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                            style="color: #74788d;"></i>
                    </div>
                    <div *ngIf="ctx.expanded" class="mt-2 pt-2 border-top">
                        <small class="text-muted d-block">{{ 'Deskripsi' | translate }}</small>
                        <small class="d-block mb-2">{{ ctx.desc | translate }}</small>
                        <small class="text-muted d-block">{{ 'Contoh Pesan' | translate }}</small>
                        <div class="bg-light rounded px-2 py-1 mt-1">
                            <small class="font-italic">"{{ ctx.sample }}"</small>
                        </div>
                        <small class="text-muted d-block mt-2">{{ 'Contoh Respon AI' | translate }}</small>
                        <div class="rounded px-2 py-1 mt-1" style="background: #e7f7ec;">
                            <small><i class="fab fa-whatsapp text-success mr-1"></i>{{ ctx.response }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'WhatsApp Agent' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <!-- ===== STEP 1 : Isi data channel ===== -->
    <ng-container *ngIf="connectStep === 1">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label col-form-label-sm">{{ 'Platform' | translate }}</label>
                        <div class="col-md-8">
                            <input class="form-control form-control-sm" type="text" [value]="connectModel.platform"
                                name="ccPlatform" disabled readonly />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Channel Name' | translate }}</label>
                        <div class="col-md-8">
                            <input class="form-control form-control-sm" type="text" [(ngModel)]="connectModel.channelName"
                                name="ccChannelName" placeholder="{{ 'Contoh: Humanis Hiraka' | translate }}"
                                autocomplete="off" />
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <label class="col-md-4 col-form-label col-form-label-sm">{{ 'AI Agent' | translate }}</label>
                        <div class="col-md-8">
                            <input class="form-control form-control-sm" type="text" [value]="connectModel.aiAgent"
                                name="ccAiAgent" disabled readonly />
                            <small class="text-muted d-block mt-1">{{ 'The agent that will reply on this channel. You can change it later.' | translate }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="float-right">
                <button type="button" class="btn btn-primary btn-sm" (click)="connectChannelNext()"
                    [disabled]="!connectModel.channelName">
                    <i class="fas fa-link font-size-14 align-middle mr-2"></i>
                    {{ 'Connect' | translate }}
                </button>
            </div>
        </div>
    </ng-container>

    <!-- ===== STEP 2 : Scan QR ===== -->
    <ng-container *ngIf="connectStep === 2">
        <div class="modal-body text-center">
            <h6 class="font-weight-bold d-inline-block border-bottom border-dark pb-2 mb-4">
                {{ 'Scan QR' | translate }}
            </h6>
            <div class="d-block">
                <div class="d-inline-block p-3 border rounded">
                    <img src="assets/images/dummy-qr.svg" alt="QR Code" style="width: 190px; height: 190px;" />
                </div>
            </div>
            <p class="text-muted mt-3 mb-2 px-3">
                {{ 'Open WhatsApp' | translate }} &rarr; {{ 'Linked Devices' | translate }} &rarr; {{ 'Link a Device' | translate }}, {{ 'then scan this code.' | translate }}
            </p>
            <div class="text-muted d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <span>{{ 'Waiting to be scanned...' | translate }}</span>
            </div>

            <hr class="my-3" />
            <!-- Konteks yang dapat dibalas Agent -->
            <ng-container *ngTemplateOutlet="agentContextSection"></ng-container>
        </div>
        <div class="modal-footer">
            <!-- Tombol simulasi (UI only) -->
            <button type="button" class="btn btn-success btn-sm" (click)="simulateConnected()">
                <i class="fas fa-check-circle font-size-14 align-middle mr-2"></i>
                {{ 'Simulasi Terhubung' | translate }}
            </button>
        </div>
    </ng-container>

    <!-- ===== STEP 4 : Info akun WhatsApp yang terhubung ===== -->
    <ng-container *ngIf="connectStep === 4">
        <div class="modal-body">
            <!-- Banner status terhubung -->
            <div class="d-flex align-items-center justify-content-between p-3 rounded"
                style="background: #e7f7ec; border: 1px solid #b7e4c7;">
                <div class="d-flex align-items-center">
                    <i class="fas fa-check-circle text-success mr-2" style="font-size: 24px;"></i>
                    <div>
                        <div class="font-weight-bold">{{ 'WhatsApp Terhubung' | translate }}</div>
                        <small class="text-muted">{{ 'Akun' | translate }}: {{ connectedInfo.accountName }} &bull; {{ connectedInfo.phone }}</small>
                    </div>
                </div>
                <button type="button" class="btn btn-outline-danger btn-sm" (click)="reconnectChannel()">
                    {{ 'Putuskan Koneksi' | translate }}
                </button>
            </div>
            <small class="text-muted d-block mt-2">{{ 'Dihubungkan pada' | translate }}: {{ connectedInfo.lastConnected }}</small>

            <hr class="my-3" />
            <!-- Konteks yang dapat dibalas Agent -->
            <ng-container *ngTemplateOutlet="agentContextSection"></ng-container>
        </div>
    </ng-container>
</ng-template>